'use strict'
exports.default = {
  common: {
    zh: '简体中文',
    tw: '繁體中文',
    ja: '日本語',
    en: 'English',
    ko: '한국어',
    title: 'Management Console',
    exit: 'Exit',
    search: 'Search',
    tel: 'Tel',
    address: 'Product location',
    scenicSpotAreaSelection: 'Select scenic spot area',
    inputRequiredTip: 'Please enter the scenic spot name',
    edit: 'Edit',
    delete: 'Delete',
    recommend: 'Recommend',
    pay: 'Pay',
    printOrder: 'Print order',
    download: 'Download',
    cancelRecommend: 'Cancel recommend',
    cancel: 'Cancel',
    confirm: 'Confirm',
    submit: 'Submit',
    searchMore: 'View more',
    prompt: 'Prompt',
    basicInfo: 'Basic Info',
    day: 'Day',
    hour: 'Hour',
    minute: 'Min',
    second: 'Sec'
  },
  title: {
    supplement: 'Additional how to use',
    addDining: 'Add product(Restaurant)',
    balanceSetting: '库存价格',
    productPriceNumber: 'Inventory price',
    productState: 'Product review',
    productAll: 'All',
    productStated: 'Wait Audit',
    productNotState: 'Audit Fail',
    orderReport: 'Order Management',
    orderDetail: 'Order details',
    scenicSpotList: 'Scenic Spot Management',
    addScenicSpot: 'Add Scenic Spot',
    editScenicSpot: 'Edit the Scenic Spot',
    scenicSpotDetail: 'Scenic spot detail',
    popularCities: 'Popular Destinations Management',
    addHotCity: 'Add Popular Destination',
    editHotCity: 'Edit Popular Destination',
    productManager: 'Product Management',
    pdfFilesManage: 'PDF File Database Management',
    supplyManageProduct: 'Sales Management of Products',
    tocDistributorManageProduct: 'TOC Sales Management of Products',
    pdfBatchList: 'Batch list',
    bulkPurchaseList: 'Bulk purchase list',
    bulkPurchaseDetail: 'Bulk purchase details',
    submitAndPayOrderBatch: 'batch purchase ',
    batchPdfFilesList: 'Batch file list',
    addPdfFiles: 'Add PDF file database',
    importPdf: 'Import PDF file',
    pdfFiles: 'PDF file',
    DiningDetail: 'Restaurant product\'s detail ',
    financeStatement: 'Automatically generate financial statements',
    statementDetail: 'Statement Detail',
    warehouse: 'Warehouse Management',
    ticketDepot: 'Ticket depot Management',
    addTicketDepot: 'Add new ticket depot',
    importTicket: 'Import ticket to depot',
    pinTicket: 'Pin ticket',
    pinTicketMagn: 'Pin ticket Management',
    trades: 'Trades Details',
    record: 'Withdraw history',
    counter: 'Counter Management',
    addCounter: 'Add counter',
    editCounter: 'Edit counter',
    liaison: 'Liaison Management',
    addLiaison: 'Add liaison',
    editLiaison: 'Edit liaison',
    updatePDFfiles: 'Edit PDF file database',
    importThirdSystemProduct: 'Product Import Management',
    productLogList: 'Product modification record',
    productLogDetail: 'Details of product changes',
    productLanguageLogList: 'Product modification record',
    productLanguageLogDetail: 'Details of product multilingual changes',
    bannerManage: 'Banner Management'
  },
  lable: {
    translation: 'AI Translation',
    translationing: 'AI Translationing...',
    translationTip: 'No data to translate',
    isOnline: 'Release Status',
    hotCity: 'Popular Destinations',
    cityName: 'Destination Name',
    cityPicture: 'Destination Picture',
    languageType: 'Language',
    sort: 'Sort',
    sortTip: 'The smaller the value, the higher the ranking',
    onlineTip: 'Will not be displayed on the client after being removed from the shelf',
    hotType: 'Popular Type',
    type1: 'Popular Area',
    type2: 'Popular Destination',
    type3: 'Popular Landmark',
    addProduct: 'Add Product',
    productInformation: 'Product Information',
    price: 'Price',
    tags: 'Tags',
    productList: 'Product List',
    bannerTitle: 'Banner Main Title',
    bannerSubTitle: 'Banner Sub Title',
    bannerImages: 'Banner Images',
    selectLogType: 'Select search type',
    selectLogType_1: 'Based on field',
    selectLogType_2: 'Multilingual field',
    inputProductId: 'Enter the product ID',
    inputProductId_placeholder: 'Enter the product ID',
    customerDataType: 'Guest profile type',
    customerDataInfo: 'Guest information',
    chooseProductLanguage: 'Select language',
    noDataForLanguage: 'No data yet, please select another language',
    newOrderEmail: 'Order notification email',
    batchStatus: 'Batch status',
    proofPath: 'Voucher link',
    pinTicketNum: 'Verify number',
    KlookTicketCanbeUsedDateTBList: ' Within six months',
    KlookTicketCanbeUsedDate: ' A day at the same price is valid for 6 months ',
    QuantityMismatch: 'If the number of tickets sold is inconsistent with the actual purchase quantity, shall we continue to sell the tickets',
    importProduct: 'import product',
    system: 'system',
    chooseSystem: 'Please select system',
    klook: 'KLOOK',
    link: 'LINK',
    thirdNum: 'Third party productId',
    enterThirdNum: 'Please enter third party productId',
    thirdProductTime: 'Time：',
    timeTips: 'Please enter time period (1-24)',
    haveInventory: 'in stock',
    noInventory: 'sold out',
    travlerFirstName: 'visitor\'s firstName',
    travlerFamilyName: 'visitor\'s familyName',
    travlerCall: 'call',
    enterGolfCourseCode: '请输入高尔夫场地编号',
    enterPrefecture: '请输入行政区域编号',
    Mr: 'Mr',
    Ms: 'Ms',
    Miss: 'Miss',
    Mrs: 'Mrs',
    duration: 'duration',
    travellers: 'Suggested number of visitors',
    voucherUsage: 'voucher usage',
    voucherTypeDesc: 'voucher type',
    voucherValidity: 'Validity period of voucher',
    redemptionProcess: 'redemption process',
    transportation: 'transportation',
    insiderTips: 'Warm prompt',
    joinAstrict: 'Participation restrictions',
    demand: 'demand',
    packageOptions: 'Package instructions',
    itinerary: 'Schedule instructions',
    additionalInformation: 'Additional information',
    meetUpLocation: 'Collection instructions',
    pickUpLocation: 'Get the address',
    surcharge: 'Overtime fee',
    location: 'address',
    submitOrderTip: 'This product is a special product and will be paid automatically after the order is submitted. Do you want to submit it?',
    submitOrderBatch: 'Please check your purchase. When sending a reservation, the total purchase amount will be automatically deducted from your AGT balance. Please be careful！',
    location_placeholder: 'Please enter address',
    duration_placeholder: 'Please enter activity duration',
    productConfirmType_placeholder: 'Please enter the confirmation type',
    transportation_placeholder: 'Please enter the mode of transportation',
    voucherTypeDesc_placeholder: 'Please enter the credential type',
    voucherUsage_placeholder: 'Please enter how to use the credential',
    voucherValidity_placeholder: 'Please enter the validity period of the certificate',
    pickUpLocation_placeholder: 'Please enter the claim address',
    redemptionProcess_placeholder: 'Please enter address',
    packageOptions_placeholder: 'Please enter the package description',
    itinerary_placeholder: 'Please enter itinerary description',
    additionalInformation_placeholder: 'Please enter additional information',
    surcharge_placeholder: 'Please enter timeout fee',
    insiderTips_placeholder: 'Please enter tips',
    updateType: 'Type modification',
    updateFloatPrice: 'Float Price',
    shareQrCode: 'share QR code',
    setQrCode: 'set QR code',
    addCoupon: 'Add new coupon',
    couponName: 'Coupon name',
    couponAmount: 'Coupon amount',
    couponOrder: 'Coupon transaction',
    couponCode: 'Coupon code',
    addCouponCode: 'New coupon code added',
    downloadCouponCode: 'Download coupon code',
    batchDelete: 'Batch deletion',
    downloadNow: '{cnt} records added successfully. Download now?',
    tipMessage1: 'Please enter a name',
    examine: 'Distributor review',
    revenueManagement: 'Manage Revenue',
    revenueDetail: 'Manage Revenue',
    cashManager: 'Manage Cash Withdrawal',
    productState: 'State selection',
    orderNum1: 'sort',
    netError: 'This product has already been taken offline at the supplier.',
    updateProduct: 'Update',
    addQrCode: 'Add Qr Code',
    pleasechoice: 'Please choose',
    identity: 'ID',
    studentId: 'Student ID card',
    officerId: 'certificate of officers',
    passport: 'passport',
    residence: 'Account book (children please choose this item)',
    hongKongandMacaopass: 'Hong Kong and Macao pass',
    cellsyndrome: 'Cell syndrome',
    identificationNumber: 'Identification Number',
    children: '(children enter birth date)',
    addressinformation: 'Address information',
    expressaddress: 'Express address',
    postalCode: 'Postal Code',
    suborderinformation: 'Suborder ID',
    subordersId: 'JTRConfirmation of order',
    qxzfbcplx: 'Please select the product type for release',
    selectTreeId: '请选择产品类型',
    ticketType: 'Ticket type：',
    jtrticketType: '类型',
    productPriceTypeSetting: 'Price type Setting',
    batchPriceRuleSetting: 'Batch price rule setting',
    specificDatePriceSetting: 'Specified date price setting',
    currentProducts: 'Current product：',
    currentProducts_saleDate: 'Date of current product online：',
    unlimited: 'Unlimited',
    setProductInventoryAndPrice: 'Price and stock setting',
    setProductPriceType: 'Set product price type',
    serialNumber: 'Account',
    period: 'Period',
    timelimit: 'Time range',
    selectDateRange: 'Select date range',
    selectTimeRange: 'Select time range',
    inventory: 'Stock',
    purchasePrice: 'Supplier price',
    jtrDistributionPrice: 'EasyGo supplier price',
    stockNum: 'Field Inventory',
    distributionPrice: 'EasyGo price',
    marketPrice: 'Market price',
    retailPrice: 'Recommended retail price',
    operating: 'Operation',
    delete: 'Delete',
    chargeback: '退单',
    addTimePeriod: 'Add time period',
    reset: 'Reset',
    save: 'Save',
    goBack: 'Return',
    confirm: 'Confirm',
    confirmOrder: 'Order detail confirmation ',
    confirmOrder1: '北海道确认订单',
    jtrconfirmOrder: 'JTRConfirmation of order',
    refuse: 'Refuse the order',
    cancelOrder: '取消订单',
    requestCancel: 'Cancel order',
    specialRequestRefund: '特殊申请退款',
    requestRefund: '申请退款',
    makeSure: 'Confirm',
    cancel: 'Cancel',
    productName: 'Product name',
    scene: '场次',
    dataSource: 'data source',
    selectDistributor: 'Select distributor',
    authorizedMerchant: 'Authorized merchant',
    businessName: 'Business name',
    priceFloatRange: 'Distribution price authorization',
    distributorNameOrNumber: 'Distributor name/number',
    distributorNumber: 'Distributor number',
    distributorName: 'Distributor name',
    changeValidTime: 'Change validity',
    // suoCountry: 'Country name',
    suoCountry: 'Country',
    suoCountrys: 'Keywords',
    productNameOrId: 'Product name/number',
    productNameOrIds: 'Destination, activity, product number, etc.',
    productNameOrIdRemark: 'Product name/number/remark/tag',
    productDiff: 'Classification',
    productDiffs: 'Categories',
    confirmMethod: 'Confirm way',
    managerArea: 'Management area',
    productCode: 'Product ID',
    golfCourseCode: '高尔夫场地编号',
    prefecture: '地方行政区域',
    suoCity: 'Popular Destination',
    confirmMethods: 'Confirm way',
    confirmMethodss: 'Confirmation',
    managerAreas: 'Management area',
    different: 'Ticket class',
    number: '人数',
    status: 'Status',
    ticketType0: 'E-ticket',
    ticketType1: 'Ticket',
    ticketType2: 'Activities & Experience',
    ticketType22: 'Activities & Experience',
    ticketType3: 'Tours',
    ticketType33: 'Tours',
    ticketType4: 'Wi-Fi',
    ticketType5: 'SIM Card',
    ticketType6: 'Cuisine',
    ticketType66: 'Cuisine',
    ticketType7: 'Transport Services',
    ticketType77: 'Transport Services',
    ticketType8: 'Package Deals',
    ticketType88: 'Package Deals',
    ticketType9: 'Overnight bus',
    ticketType99: 'Overnight bus',
    jtrticketType0: 'Admission ticket',
    jtrticketType1: 'A package or a packaged product',
    jtrticketType2: '自由行',
    jtrticketType3: '线路',
    jtrticketType12: '预售',
    isOnlinePay0: '线下',
    isOnlinePay1: '线上',
    isOnlinePay2: 'Online payment',
    isOnlinePay3: '酒店前台现付（返佣）',
    confirmType0: 'Instant confirmation',
    confirmType00: 'Instant confirmation',
    confirmType1: 'Delayed confirmation',
    confirmType11: 'Delayed. Confirmation within',
    confirmType12: 'Delayed Confirmation',
    confirmType2: 'hours.',
    productSource0: 'JPH Product',
    productSource1: 'Partner Product',
    status0: 'Wait audit',
    status1: 'Audit pass',
    status2: 'Audit fail',
    status3: 'Offline',
    status4: 'Draft',
    online: 'Online',
    checkAll: 'View',
    faverite0: 'Recommend',
    faverite1: 'Not Recommend',
    toldAllLeft: 'Directions: Reserve at',
    toldAllMiddle: 'Days',
    toldAllMiddles: 'days in advance at ',
    toldAllRight: '.',
    orderEmergentTag: 'Urgent',
    orderUncertainTag: 'Pending',
    orderConfirmedTag: 'Confirmed',
    orderCancellingTag: 'Cancelling',
    orderCanceledTag: 'Canceled',
    orderCompletedTag: 'Completed',
    orderExpiredTag: 'Expired',
    orderPaymentTag: '已支付（JTR）',
    orderRefundedRequestTag: '已申请退款（JTR）',
    orderRefundedTag: 'Refunded',
    orderUnpaidTag: 'Unpaid',
    otherSelection: 'Other selection',
    remark: 'Remark',
    createRoleRemark: 'General user account,administration use,etc.',
    productHighlights: 'Highlight',
    currentState: 'Current status',
    youHave: 'You have',
    processOrder: 'Days to deal with this order',
    toPayOrder: 'To pay this order',
    OrderHistory: 'Order timeline',
    orderDisExplain: 'Additional order remarks (Distributor view only)',
    orderDisExplains: 'Remarks (only visible to the supplier)',
    CustomersInvisible: 'Remarks(for communication with suppliers)',
    SupplierInvisible: 'Customer message',
    addRemark: 'Add remarks',
    addMessage: 'Add message',
    addExplain: 'Add remarks',
    confirmation: 'Are you sure to confirm this order?',
    confirmationPdf: '确认作废此PDF吗',
    confirmationticket: '确认作废此实体票吗',
    specialRefundConfirm: '确认退款后钱款将会全额返还给分销商,是否确认',
    specialRefundCancel: '拒绝退款则订单会继续进行下去',
    DeleteConfirmation: 'Do you really want to delete it?',
    refusal: 'Are you sure to refuse this order?',
    voucherPath: 'Voucher',
    messageInfo: 'Order reserve info',
    orderID: 'Order ID',
    sonOrderID: 'Order ID',
    jtrOrderId: 'channel Order ID',
    orderSource: 'Order source',
    useDate: 'Reservation closes',
    sonProduct: 'Subproducts',
    useDates: 'Selected date',
    useDate1: 'Specified date',
    travelDate: 'Selected date',
    createTime: 'Order date',
    endTravelDate: 'End time',
    arrivedTime: '到达时间',
    touristRemarks: '游客备注',
    reserveNum: '预定数量',
    linkMan: 'Contact name',
    warnning1: '必须真实姓名，用于景区验证',
    linkPhone: 'Contact phone',
    linkEmail: 'Contact mailbox',
    linkAddress: 'Delivery address',
    linkCode: '邮政编码',
    linkCreditType: 'Type of contact document',
    linkoptionA: '身份证',
    linkoptionB: '护照',
    linkCreditNo: '联系人证件号码',
    customerUseDate: 'Ticket use date',
    customerTravelDate: '游玩日期',
    customerEndTravelDate: '游玩结束日期',
    customerArriveTime: '到达日期',
    customerGetTicType: '取票方式',
    customerGetTicType0: '免费',
    customerGetTicType1: '快递费',
    distributor: 'Distributor',
    PDFSendingMode: 'PDF E-ticket sending method',
    productPrice: 'Product price',
    Purchase: 'Supplier price',
    distributionPriceToc: 'distribution Price',
    distributionPriceSum: 'distribution PriceSum',
    productSalePrice: 'The floating price of the product',
    productMinPrice: 'Minimum price (for display)',
    productTcPrice: 'Product offset price',
    buyNum: 'Quantity',
    seatName: 'Name of field',
    jtrAppendNum: 'Add quantity',
    primarynum: 'Original quantity',
    cancelNum: 'Cancellations',
    orderCnt: 'Number of successful',
    totalAmount: 'Total cost',
    customerInfo: 'Customer Info',
    customerName: 'Name',
    cusEmail: 'Email address',
    Email: 'Email address',
    receiveDate: 'Ticket collection date',
    returnDate: 'Return Date：',
    FileImport: 'Import file',
    upload: 'Upload',
    onlyUpload: 'Only upload',
    noMoreThan: 'Files, no more than',
    generateOrder: 'Generate order',
    thisOrder: 'This order consumed at',
    hasConsumed: 'By customer',
    noData: 'No data',
    viewName: 'Scenic spot name',
    viewLocal: 'Location',
    viewAddress: 'Address',
    viewPicture: 'Scenic spot picture',
    viewRemark: 'Scenic spot remark',
    viewTelephone: 'Scenic spot Tel.',
    payOrder: 'Order payment',
    jtrpayOrder: 'JTR Payment order',
    jtrAppend: 'Additional orders',
    operated: 'Operation',
    productSource: 'Product Sources',
    searchType: 'Select search type',
    searchType1: 'Order ID',
    searchType2: 'Product name',
    searchType3: 'Customer name',
    searchType4: '',
    searchType5: 'Customer email',
    searchType6: 'Channel ID',
    searchType7: 'Tag',
    system1: 'ToB',
    system2: '2cycle System',
    system3: '乐天系统',
    productConfirmType: 'Confirmation',
    reserve: 'Reserve',
    isOnlinePay: 'Payment method',
    startDate: 'Earliest possible date of use',
    maxNum: 'Max per order',
    minNum: 'Min per order',
    startNum: 'Min per order',
    isExpress: 'Does it support express delivery',
    yesExpress: '支持',
    noExpress: '不支持',
    expressPrice: 'Distribution cost',
    priceStartDate: '价格开始时间',
    priceEndDate: '价格结束时间',
    priceDate: 'Product online duration',
    soldNum: 'Sales status',
    soldNumSort: 'Best Sellers',
    ticketCount: '销量',
    sourceType: 'source',
    sourceType1: 'JPH',
    sourceType2: 'JTR',
    sourceType3: 'KLOOK',
    supplySourceType1: 'JPH',
    supplySourceType2: 'JTR',
    supplySourceType3: 'KLOOK',
    supplySourceType4: 'TWOCYCLE',
    supplySourceType5: 'LINK',
    haveNoReserve: 'Sold Out',
    upTime: 'Online time',
    productReserve: 'Reserve product',
    pictureDown: 'Download picture',
    voideDown: 'Video download',
    fileDepot: '文件仓库',
    takeView: 'Similar products',
    productNumber: 'Product ID',
    supplier: 'Supplier',
    operator: 'Operator',
    useFate: 'How to use',
    supplement: 'Additional how to use (shown in QR code voucher email)',
    supplements: 'Additional how to use',
    ticketTypeName: 'Ticket type',
    isOnlinepay: 'Payment method',
    num: 'Piece',
    nums: 'Booked',
    num01: 'booked',
    money: '￥',
    serviceLanguage: 'Service language',
    productPeople: 'Age limit',
    takeTimeDesc: 'Business hours',
    productUpTime: 'Product online period',
    diningTime: 'Dinning time',
    diningPeople: 'Dinning people',
    useTime: 'Use time',
    trafficMethod: 'How to get there',
    moneyContant: 'Price includes',
    moneyNotContant: 'Price excludes',
    priceOrFloat: 'Price/Stock',
    diningDescription: 'Product detail',
    picture: 'Picture',
    titles: 'Title',
    numberBuy: 'Quantity',
    reserveDescription: 'Reservation details',
    beforeDay: 'Reservation deadline',
    minteBefore: 'Minutes before to reserve',
    usingDate: 'Effective date',
    canBeUseDate: 'Ticket valid duration',
    canBeUseDate1: 'Ticket valid date',
    returnMethod: 'Change & refund',
    returnDescription: 'Additional policy details',
    reserveNotice: 'Additional reservation notes',
    importantNote: 'Important notice',
    userNote: 'Additional reservation notes',
    changeMethod: 'Ticket exchange method',
    comnicationPeople: 'Reservation inquiry',
    contionMen: 'Contact',
    telphone: 'Contact method',
    welcomeData: 'Reception hours',
    productDescription: 'Product Description',
    dangerConcationMen: 'Emergency contact',
    productPackageContainDetail: 'Set content detail',
    productPackageDetail: 'Set product detail',
    productContainDetail: 'Product content detail',
    SIMSize: 'SIM card size',
    netCover: 'Network coverage',
    threeGNetCover: '3G quota',
    fourGNetCover: '4G quota',
    parts: 'Accessories',
    SIMProductDetail: 'SIM card detail',
    WIFIProductDetail: 'Wifi detail',
    tourProductDetail: 'One/Multi day tour detail',
    ticketProductDetail: '门票详情',
    packageProductDetail: '套餐或打包产品详情',
    freeTourDetail: '自由行详情',
    routeDetail: '路线详情',
    advanceDetail: '预售详情',
    toursTime: 'Tour length',
    travelStyle: 'Transport purpose',
    trafficStyle: 'Transport vehicle',
    startCourtyOrEnd: 'Departure city/Destination',
    jtrPeopleNum: 'No.of adults ticket included',
    jtrChildrenNum: 'No.of child ticket included',
    peopleNum: 'Minimum no.of people per tour',
    buyMessage: 'Purchase info',
    tourDetail: 'Tour detail',
    giveClass: 'Free part',
    trafficProductDetail: 'Transportation detail',
    ybProductDetail: 'Overnight bus detail',
    //  takePomStyle: '1.Ticket exchange way',
    takePomStyle: '',
    longWord: 'QR code will be sent to the provided email address. Bring the QR code to the counters listed below to exchange for ticket.',
    //  canBeTakePom: '2.Exchange counter',
    canBeTakePom: '',
    counterLink: 'Exchange counter',
    orderMessages: 'New contact',
    saleTimes: 'Business hour',
    telphoneCommicta: 'Tel number：',
    jtrOrderVaildType0: '游客选定的游玩日期当天有效',
    jtrOrderVaildType1: 'Valid for',
    jtrOrderVaildType2: 'valid from booking date to',
    jtrOrderVaildType3: 'Valid for',
    jtrOrderVaildType4: '游客选定日期截止到',
    orderVaildType0: 'Valid only for selected use date',
    ordervaildType12: 'Valid for',
    ordervaildType1: 'days from booking date',
    ordervaildType2: 'Valid from booking date to',
    ordervaildType3: 'days from booking date',
    ordervaildType4: 'Valid for',
    ordervaildType5: 'Valid from selected use date to',
    ordervaildType55: 'Valid from selected use date to',
    ordervaildType6: 'Valid from',
    ordervaildType7: 'to',
    ordervaildType8: '',
    ordervaildType9: 'Valid from',
    ordervaildType10: 'days before selected date to',
    ordervaildType11: 'days after selected date',
    ordervaildType13: 'days from selected use date',
    ordervaildType14: ' ',
    ordervaildType15: ' ',
    orderRefundType0: 'No change or refund',
    orderRefundType1: 'Refundable before use',
    orderRefundType4: '游玩日期',
    orderRefundType5: '天前可以退款',
    orderRefundType3: 'Your order has expired, the system does not provide refund service!',
    orderRefundType7: '您的订单产品属于不可退款类型，无法提供退款服务！',
    orderRefundType6: '此订单您尚未支付，无法退款',
    eleDetail: 'E-ticket detail',
    jtrticketDetail: '门票产品详情',
    entityDetail: 'Ticket detail',
    experienceDetail: 'Experience detail',
    detail3: 'One/Multi day detail',
    detail4: 'WIFI detail',
    detail5: 'SIM card detail',
    detail6: 'Restaurant detail',
    detail7: 'Traffic detail',
    detail8: 'Set product detail',
    eleDetailPreview: 'E-ticket preview',
    entityDetailPreview: 'Ticket preview',
    experienceDetailPreview: 'Experience product preview',
    tourPreview: 'One/Multi day tour preview',
    wifiPreview: 'WIFI preview',
    simPreview: 'SIM card preview',
    diningPreview: 'Restaurant preview',
    trafficPreview: 'Traffic preview',
    packagePreview: 'Set product preview',
    spread: 'Sheet',
    diningDetail: 'Restaurant detail',
    diningDetailPreview: 'Restaurant preview',
    orderStatus: 'Order status',
    floatPrice: '浮动价格',
    ifOnLine: 'Online status',
    onLine: 'Online',
    isEdit: 'Waiting for on-line',
    offLine: 'Offline',
    SalesSituation: 'Sales',
    orderNum: 'Order',
    copyOperating: 'Copy',
    graphicEditing: '图文编辑',
    revoke: 'Revoke review',
    modify: 'Edit',
    jtrModifylanguage: 'Multilingual Edit',
    more: 'More',
    distributionAuthorization: 'Distribution Authorization',
    specialPrice: 'Special Price',
    specialPriceSet: 'Distributor Special Price Setting',
    distributionRange: 'Distribution Range Authorization',
    distributionRangeAll: 'All merchant',
    distributionRangeYes: 'Only designated merchant can distribute',
    distributionRangeNo: 'Except designated merchant can distribute',
    merchantRangeAll: 'All Merchants',
    merchantRangeYes: 'Designated Merchants',
    merchantRangeNo: 'Except Designated Merchants',
    specifiedRange: 'Range',
    account: 'Account',
    PDFSendWay: 'PDF Send Way',
    PDFOnLine: 'Online',
    PDFOffLine: 'Offline',
    connectInformation: 'Connect Info',
    dialogCancel: 'Cancel',
    dialogSure: 'Confirm',
    dialogSave: 'Save Changes',
    selectProCategory: 'Please select the product type',
    ticketsMessage: 'Ticket for recreation facilities directly entering or consuming with QR code.',
    ticketsMessage2: 'Entity tickets for scenic spots or recreation facilities changing with QR code and using.',
    ticketsMessage3: 'Ticket for recreation facilities changing or directly consuming on the spot with QR code.',
    ticketsMessage4: 'one day tour、servel days tour、car rental tour products',
    ticketsMessage5: 'Wi-Fi rental',
    ticketsMessage6: 'SIM internet-access card',
    ticketsMessage7: 'table reservation, set meals booking',
    ticketsMessage8: 'traffic tickets，airport pickup，car rental products',
    ticketsMessage9: 'discount price for combination products',
    ticketsMessage10: 'Overnight bus products',
    serialNumbers: 'No.',
    belongArea: 'Belong Area',
    connectWay: 'Connect Way',
    purchasingSituation: 'Purchasing Situation',
    proStatus: 'Status',
    ifOnlineStatus: 'Online Status',
    today: 'Available today',
    tomorrow: 'Available tomorrow',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    checkPassword: 'Check Password',
    limitDay: 'Other',
    limitDays: 'Availability',
    auditCannot: 'Reasons for audit failure：',
    notMust: 'No limit',
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    afternoonTea: 'Afternoon Tea',
    dinner: 'Dinner',
    buffet: '自助餐',
    bus: '班车',
    caddie: '球童',
    cart: '高尔夫球具车',
    overnight_accommodation: '住宿一晚',
    play_early: '提前玩',
    play_through: '优先玩',
    play_through_am: '上午优先玩',
    play_through_pm: '下午优先玩',
    nightSnack: 'Night Snack',
    singleMeal: 'Single Meal',
    doubleMeal: 'Double Meal',
    thirdMeal: 'Meal for three to four people',
    fiveMeal: 'Meal for five to ten people',
    tenMeal: 'Meal for more than ten people',
    haveMustData: 'Have specific time',
    common: 'Common',
    species: 'Species',
    dayBefore: 'Day Before',
    applyToRefund: '(local time)Apply a refund before.',
    updateNotAudited: 'Edit the reason for audit failure',
    pleaseEnterAudited: 'Please enter the reason for audit failure',
    updateSuccess: 'Update Success！',
    updateFliture: 'Update Failed！',
    submitError: 'Sorry,submit the audit error, please try again',
    letterCounter: 'Return to the counter',
    car: 'Car',
    tram: 'Tram',
    cruise: 'Cruise',
    tourDetailTemp: 'Tour Details',
    auditingProductNum: 'Auditing Product Quantity',
    productNum: 'Quantity',
    orderSum: 'Order Quantity',
    payBySupplierNum: 'Turnover',
    balanceNum: 'Balance',
    productOrderNum: 'Number of platform products',
    distritorNum: 'Number of Distritor',
    supplierNum: 'Number of Supplier',
    urgentNum: 'Urgent Order',
    confirmNum: 'Confirmed',
    unpassNum: 'Audit Unpass Product',
    beConfirmNum: 'Orders to be confirmed',
    cancelingNum: 'Canceling Orders',
    unPaymentNum: 'Unpaid Orders',
    cancelingOrder: 'Canceling Order',
    becancelOrder: 'Cancelled',
    auditingProduct: 'Auditing Product',
    supplierAuditing: 'Auditing Supplier',
    distributorAuditing: 'Auditing Distributor',
    notice: 'Notice',
    releaseNotice: 'Release Notice',
    haveNotNotice: 'No Notice！',
    unRead: 'Unread',
    readed: 'Read on',
    unReadNotice: 'Unread Notice',
    noticeDetail: 'Notice Detail',
    messageStart: 'Message Start',
    messageMiddle: 'Come into effect. Admin to',
    messageEnd: 'Release Message',
    country: 'Country',
    province: 'Province',
    city: 'City',
    area: 'Area',
    year: '/',
    month: '',
    one: 'Monday',
    two: 'Tuesday',
    three: 'Wednesday',
    four: 'Thursday',
    five: 'Friday',
    six: 'Saturday',
    seven: 'Sunday',
    buyPrice: 'Purchase Price',
    selectSupplier: 'Select Supplier',
    updloadFiles: 'Updload Files：',
    pleaseChange: 'Please Select',
    auditMessageEnter: 'Booking Message Enter',
    auditMessageEnter1: '',
    enterAmount: 'Quantity',
    pleaseEnterProductAmount: 'Please Enter Product Amount',
    endSlary: 'Order subtotal',
    endTotalAmount: 'Total',
    ridePlace: 'Boarding location',
    getOnTheTrain: 'Boarding location',
    onTrainTime: 'Boarding time',
    choseUpPlace: 'Please select boarding location',
    choseDownPlace: 'Please select arrival destination',
    getDownTheTrain: 'Arrival destination',
    downTrainTime: 'Arrival time',
    orderMessageByMe: 'Order details',
    confirmEmail: 'Recipient email',
    aboutTipMessage: 'The email must be checked for QR code and any guest detail mistakes',
    aboutOrderLanguageType: 'Order language',
    aboutChangeData: 'Select Date',
    travler: 'Guest',
    mainTravler: 'Guest representative',
    travlerName: 'Name',
    travlerPhone: 'Phone',
    customerEmail: 'E-mail',
    customerWechat: 'Wechat',
    customerPassport: 'Passport',
    customerSex: 'Sex',
    orderByMessage: 'Additional information',
    orderExplain: 'Additional order remarks',
    productUseData: 'How to use',
    canBeTaken: ' Counter can be taken',
    mustBeComplate: 'Full name must be provided for identification purposes',
    productCanBeReciveTo: 'This product needs to send a text message or E-mail to the guest, and the phone number or E-mail must be filled in (please fill in the E-mail if the non-chinese mobile phone).',
    submitOrder: 'Submit Order',
    nowPages: 'Current Product',
    travlerEmail: 'Recipient email',
    travlerWebchat: 'Webchat',
    travlerPassport: 'Passport',
    travlerAddress: '邮寄地址',
    travlerPostCode: '邮政编码',
    travlerCreditType: '证件类型',
    travlerCreditNo: '证件号码',
    travlerSex: 'Sex',
    mustToWrite: 'Must to Write',
    notMustToWrite: 'Optional',
    orderStatus0: 'Order generated.',
    orderStatus1: 'Order payment processed.',
    orderStatus2: 'Cancel the order（Distritor）',
    orderStatus3: 'Cancel the order（Supplier）',
    orderStatus4: 'Confirm the order',
    orderStatus5: 'Order has been exchanged/used. Order complete.',
    orderStatus6: 'Cancel the order without payment',
    orderStatus7: 'Refuse the order',
    orderStatus8: 'Confirm to cancel the order',
    orderStatus9: 'Refuse to cancel the order',
    orderStatus10: 'Order confirmed automatically.',
    orderStatus11: 'Automatic to complete the order',
    orderStatus12: 'Automatic to cancel the order',
    orderStatus13: 'Payment times out and the order is cancelled automatically.',
    orderStatus14: '申请退款',
    orderStatus15: '确认退款',
    orderStatus16: '拒绝退款',
    orderStatus17: '订单已核销',
    orderStatus18: 'Order confirmed',
    orderStatus19: 'Carrier Special Cancel',
    orderStatus20: 'Special cancellation of pass',
    orderStatus21: 'Automatic processing of expired orders',
    orderStatus22: 'Cancel API of connection destination',
    orderStatus23: 'One side cancellation of system',
    notPaymentTag: 'Cancel without payment',
    travelsSelectData: '',
    jtrOrderRefund0: 'Ticket change/refund for free until ',
    jtrOrderRefund1: '游玩日期后',
    jtrOrderRefund2: ' days prior to reserved date',
    jtrOrderRefund3: 'Ticket change/refund for free within its valid period',
    jtrOrderRefund4: ' 天可退款',
    day: 'days prior to selected date',
    ticketPrice: 'ticket price.',
    refundPayment: 'change/refund fee is',
    cancelCannot: 'Reason for Canceling',
    refundCannot: 'Grounds for refunds',
    cancelOrRefund: 'Reason for Refusing',
    cancelReason: '取消理由',
    admin: 'Admin',
    clerk: 'Clerk',
    refuseCannot: ' Reasons for Refusing',
    updateTime: 'Update Time',
    counterDetails: 'Counter',
    applyDate: 'Apply Date',
    pleaseIntoCancelReason: 'Please enter the reasons for refusing',
    pleaseIntoCancelCannot: 'Please enter the reason for canceling',
    pleaseIntoInfo: '请输入文字',
    applyType: {
      applyType0: 'Distributor',
      applyType1: 'Supplier',
      applyType2: 'Admin',
      applyType3: 'Clerk',
      applyType4: 'Other'
    },
    adminAccount: {
      createUser: 'Add Role',
      roleName: ' User Name',
      createRoleName: ' Role name',
      account: 'Account Affiliation',
      applyType: 'Types',
      isEnable: 'Disable or Enable',
      enable: 'Enable',
      disable: 'Disable',
      roleDistribution: 'Authority',
      roleManager: 'Create role',
      authMenu: 'Set Menu Access Permission',
      checkAll: 'Select All'
    }
  },
  viewMessage: {
    message1: 'Sure to save or not?',
    message2: 'Please enter the name of the scenic spot',
    hotCity_message2: 'Please enter the name of the destination',
    hotCity_message19: 'Length must be 1 to 200 characters',
    hotCity_remark_placeholder: 'Please enter remark',
    message3: 'Please enter the address of the scenic spot',
    message4: 'Recommend to use',
    message5: 'Sure to save or not?',
    message6: 'Sure to save or not?',
    message7: 'Sure to save or not?',
    message8: 'Please select the location of the scenic spot',
    message9: 'The length is 3 to 50 characters',
    sysError: 'System Error!',
    revokeMessage: 'This operation will revoke audit, continue or not?',
    revokeSuccess: 'Revoke Audit Success!',
    revokeHavePassed: 'The product audit has been passed and can\'t be revoked!',
    revokeHaveNotPassed: 'The product audit hasn\'t been passed and can\'t be revoked.Please resubmit your application!',
    revokeOperationCanceled: 'Revoke audit has been cancelled!',
    offLineMessage: 'This operation will remove the product from shelves, continue or not?',
    offLineSuccess: 'OffLine Success!',
    offLineOperationCanceled: 'Offline operation has be canceled',
    onLineSuccess: 'OnLine Success!',
    onLineMessage: 'This operation will put the product on shelves, continue or not?',
    deleteMessage: 'This operation will permanently delete the product, continue or not?',
    deleteMessageOrder: 'This operation will permanently delete the order, continue or not?',
    deleteSuccess: 'Delete Success!',
    deleteOperationCanceled: 'Delete operation has been canceled!',
    thisRangeNotEmpty: 'Merchant within the specified range can\'t be empty!',
    thisPriceRangeNotEmpty: 'Merchant distribution price authorization can\'t be empty!',
    thisPriceRangeNotNum: 'Please enter the number!',
    editSuccess: 'Edit Success!',
    pleaseDeletePackageProduct: 'Please delete the package first, or remove the product from the package!',
    upToLine: 'After this operation, the product will go online, continue or not?',
    newToUse1: 'After this operation, the product will change the batch status to close, continue or not?',
    newToUse0: 'After this operation, the product will change the batch status to normal, continue or not?',
    fileToDelete: 'After this operation, the files library will be permanently deleted, continue or not?',
    useSuccess: 'Operation Success',
    useFail: 'Operation Fail',
    holdSuccess: 'Save Success!',
    holdError: 'Save Fail!',
    maxDay: 'Set a max of 10 year\'s data at a time',
    submitSuccess: 'Submit Success!',
    submitSuccessconfirmed: '提交成功！等待确认！',
    submitError: 'Submit Fail!',
    balanceNotDone: 'Your account balance is not enough, please recharge and complete this order',
    balanceDone: 'Congratulations, pay success',
    cancelDone: 'Your cancellation request has been sent, please wait for the merchant to handle it',
    cancelDone2: 'Cancelled and refunded! Please refresh the page to confirm',
    cancelDone3: '您的退款申请已发送，请等候商户处理',
    cancelError: 'Merchant balance is not enough, order can\'t be cancelled temporarily',
    cancelError1: '系统异常，请联络管理员',
    message10: 'Whether to save editing?',
    lable1: 'Cancel',
    lable2: 'Not Save',
    lable3: 'Save',
    message11: 'The length is 3 to 50 characters',
    message12: 'Please Select Country',
    message13: 'Please Select Region',
    message14: 'The length is 3 to 50 characters',
    message15: 'The basic information is incomplete',
    message16: 'Whether to give up editing?',
    message17: 'The scenic spot is in use, can\'t delete!',
    confirmDone: ' Confirm Success',
    tipMessage1: 'Please enter the remark for the role',
    tipMessage2: 'The input length is no more than 255 digits',
    tipMessage3: 'Please enter the role name',
    tipMessage4: 'The input length is no more than 100 digits',
    tipMessage5: 'Commission rate must be an integer (whole number) from 0-100. ',
    messageNotCompleteIn: 'The necessary information is incomplete',
    orderStatusHadUpdate: 'Status of the order has been updated',
    orderRefundFalse: '订单退款申请失败',
    message18: 'The length is 0 to 500 characters',
    message19: 'The length is 3 to 500 characters',
    message20: 'It already exists.',
    cleckOrder: 'Confirmation Write off Order',
    cleckOrderCanceled: 'Cancel',
    cleckSucc: 'Success Write off',
    banner_save_success: 'Banner saved successfully!',
    banner_save_error: 'Failed to save banner!'
  },
  counterMessage: {
    counterName: 'Counter Name',
    counterAddress: 'Counter Address',
    counterTelephone: 'Counter Telephone',
    busineTime: 'Opening Hours',
    counterPic: 'Counter Pic',
    lable1: 'Cancel',
    lable2: 'Not Save',
    lable3: 'Save',
    message1: 'Please enter the counter name',
    message2: 'This operation will permanently delete the counter, continue or not?',
    message3: 'Delete Success',
    message4: 'In use，can\'t be deleted',
    message5: 'Upload picture of the counter',
    message6: 'Whether to save editing?',
    message7: 'Please enter the counter name',
    message8: 'Please enter the counter address',
    message9: 'Please enter the counter phone',
    message10: 'Please enter the correct counter phone',
    message11: 'The length is between 6 and 500 characters',
    message12: 'Please enter the reception time of the counter',
    message13: 'Save Fail',
    message14: 'Save Success',
    message15: 'Whether to give up editing?',
    message16: 'The length is between 1 and 500 characters'
  },
  liaisonMessage: {
    liaisonName: 'Name',
    liaisonTelephone: 'Contact Way',
    receptionTime: 'Reception Time',
    message1: 'Please enter contact name',
    message2: 'Please enter contact telphone',
    message3: 'Please enter the contact person reception time',
    message4: 'Sure to delete this contact?',
    message5: 'Delete Success',
    message6: 'In use，can\'t be deleted',
    message7: 'Whether to save editing?',
    message8: 'Cancel',
    message9: 'Not Save',
    message10: 'Save',
    message11: 'Save Fail',
    message12: 'Whether to give up editing?',
    message13: 'Save Fail',
    message14: 'Save Success'
  },
  registerMessage: {
    directorWechatComment: 'In order to quickly introduce the company and so on,the recommended use of the service.Please confirm the instruction manual separately distributed in detail.',
    supplierRegister: 'Supplier Register',
    distributorRegister: 'Distributor Register',
    accountInfo: 'Account Info',
    companyInfo: 'Company Info',
    mainBusiness: 'Main Business (We will recommend the fit products to you base on these)',
    mainBusiness1: 'Main Business',
    saleType: 'Sales Method (OTA)',
    trafficCardTicket: 'Transportation',
    carFree: 'Private car service',
    admissionToThePark: 'Entry ticket',
    foodAndBeverage: 'Restaurant Reservation',
    oneDayTour: 'Day tour',
    daysTour: 'Day tour(2days or above)',
    characteristicExperience: 'Activity',
    hotel: 'Hotel',
    physicalShop: 'Shop',
    fzShop: 'Figgy',
    mfwShop: 'Mafengwo',
    tbShop: 'Taobao',
    xcShop: 'Ctrip',
    tcShop: 'Tongcheng',
    qneShop: 'Qunaer',
    tnShop: 'Tu niu',
    cupang: 'Cupang',
    gmarket: 'Gmarket',
    entry: 'Please Entry',
    directorInfo: 'Business Leader Info',
    account: 'Login Account',
    password: 'Enter Password',
    passwordConfirm: 'Password Confirm',
    address: 'Location',
    companyName: 'Company Name',
    logo: 'Company Logo',
    legalRepresentative: 'Legal Person',
    companyAddress: 'Company Add.',
    companyTelephone: 'Company Tel.',
    companyEmail: 'Company E-mail',
    companyWebsite: 'Web/Store Link',
    bankCardNumber: 'Bank account',
    qualification: 'Qualification',
    directorName: 'Name',
    directorTelephone: 'Telephone',
    directorPosition: 'Position',
    directorWechat: 'Wechat ID',
    directorEmail: 'E-mail',
    directorCard: 'Business Card',
    directorCode: 'Invited Code',
    phDirectorCode: 'Please enter the invited code',
    directorCodeTip: 'Enter an invitation code to enjoy priority review and many other exclusive benefits',
    phAccount: 'Please enter the login account',
    phPassword: 'Please enter the login password',
    phPasswordConfirm: 'Please confirm the login password',
    phCompanyName: 'Please enter the company\'s official registration name',
    phLogo: 'Upload Company Logo',
    phLegalRepresentative: 'Please enter the company\'s legal person',
    phCompanyAddress: 'Please enter the company detailed address',
    phCompanyTelephone: 'Please enter the company telephone',
    phCompanyEmail: 'Please enter the company E-mail',
    phCompanyWebsite: 'Please enter the company\'s official website(Or other platform store links)',
    phBankCardNumber: 'Please enter the company bank account',
    phQualification: 'Scan company registration certificate of qualification',
    phDirectorName: 'Please enter the name',
    phDirectorTelephone: 'Please enter the telephone',
    phDirectorPosition: 'Please enter the position',
    phDirectorWechat: 'Please enter the webchat ID',
    phDirectorEmail: 'Please enter the E-mail',
    phDirectorCard: 'Please upload the card',
    submitResigt: 'Submit Application',
    message1: 'Please enter 6-16 upper and lower case letters or digits',
    message2: 'Please make sure the account info is correct',
    message3: 'Please enter password',
    message4: 'Please enter the correct password',
    message5: 'The length is 6 to 16 characters',
    message6: 'Please enter password again',
    message7: 'The two passwords differ!',
    message8: 'Please enter the correct password',
    message9: 'Please Select Country',
    message10: 'Please enter the company\'s official registration name',
    message11: 'The length is 6 to 200 characters',
    message12: 'Please upload company Logo',
    message13: 'Please enter the company\'s legal person',
    message14: 'The length is 2 to 200 characters',
    message15: 'Please enter the company detailed address',
    message16: 'The length is 10 to 200 characters',
    message17: 'Please enter the company telephone',
    message18: 'Please enter the correct telephone number',
    message19: 'The length is 6 to 20 characters',
    message20: 'Please enter the company E-mail',
    message21: 'Please enter the correct company E-mail',
    message22: 'The length is 7 to 50 characters',
    message23: 'Please enter company official website',
    message24: 'The length is 4 to 300 characters',
    message25: 'Please enter the company bank account',
    message26: 'Please enter the correct company bank account',
    message27: 'The length is 10 to 100 characters',
    message28: 'Please upload the company\'s formal qualification certificate',
    message29: 'Please enter the business owner\'s name',
    message30: 'The length is 2 to 50 characters',
    message31: 'Please enter telephone',
    message32: 'Please enter correct telephone',
    message33: 'The length is 6 to 20 characters',
    message34: 'Please enter the position',
    message35: 'The length is 2 to 50 characters',
    message36: 'Please enter the WeChat ID',
    message37: 'The length is 6 to 50 characters',
    message38: 'Please enter the business owner\'s card',
    message39: 'Submit registration or not?',
    message40: 'Register Success',
    message41: 'Register Fail',
    message42: 'Please enter the account',
    message43: 'The length is 6 to 30 characters',
    message44: 'The user name already exists',
    message45: 'Please enter the E-mail',
    message46: 'The length is 5 to 50 characters',
    message47: 'Please enter the correct E-mail',
    message48: 'E-mail already registered',
    message49: 'Give up registering or not?',
    message50: 'Check at least one of the main businesses and multiple choices are allowed',
    message51: 'Check at least one sales method, multiple choices are allowed',
    message52: 'This information is required when other options are selected',
    message53: 'The maximum length of the input is 20'
  },
  menu: {
    sysHome: 'Home',
    product: 'Manage Products',
    productList: 'My Products',
    releaseProducts: 'New Product',
    releaseThirdProducts: '发布第三方产品',
    supplyManageProduct: 'Manage BtC Products',
    importThirdSystemProduct: 'Import Third Party Product',
    conciseEticket: 'Release E-ticket Products',
    conciseTicket: 'Release Ticket Products',
    conciseTravel: 'Release Travel Products',
    conciseWifi: 'Release WiFi Products',
    conciseSIM: 'Release SIM Products',
    conciseDining: 'Release Dining Products',
    conciseTransport: 'Release Transport Products',
    conciseDiscount: 'Release Discount Products',
    conciseSetMeal: 'Add packaging products',
    conciseExperience: 'Release Experience Products',
    productAuditing: 'Product Auditing',
    addBusFlag: 'Issuing overnight bus product. ',
    orderManagement: 'Manage Orders',
    orderManagementC: 'C-terminal management',
    operatorOrderManagement: 'Manage Orders',
    operatorOrderMagnToC: 'ToC Order Management',
    operatorOrderManagement_chargeback: '订单退单权限',
    reserve: 'Products',
    distriOrderMagn: 'Manage Orders',
    disTocOrderManagement: 'ToC Order Management',
    bulkPurchaseList: 'Manage Bulk Order',
    tocDistributorManageProduct: 'ToC Sell Products',
    distriOrderMagnToC: 'ToC Order Management',
    applyDistribution: 'Retailer review',
    revenueManagement: 'Manage BtoC Distributor',
    revenueDetail: 'Manage ToC Revenue',
    applyCash: 'Manage ToC Cash Withdrawal',
    operatApplyCash: 'ToC Withdrawal Management',
    coupon: 'ToC Coupon management',
    pinTicketMagn: 'Manage verified Vouchers',
    ticket: 'Manage Stock',
    ticketDepot: 'Manage Tickets',
    warehouse: 'Warehouse Stock',
    userDepot: 'Manage User Warehouse',
    pinTicket: 'Verify QR Voucher',
    pdfTicket: 'Manage E-tickets',
    pdfFiles: 'PDF File Library',
    shopManage: 'Manage Partner Company',
    distributor: 'Manage Distributor',
    supplier: 'Manage Supplier',
    scenicSpot: 'Manage Similar Products',
    scenicSpotList: 'Similar Products List',
    finance: 'Financial Statistics',
    financeStatement: 'Financial Statements',
    financeDetail: 'Financial Statement Details',
    ActuarialManagement: 'Actuarial Management',
    withdrawals: 'Transaction History',
    operatorWithdrawal: 'Recharge/Withdrawal',
    trades: 'Order History',
    record: 'Recharge/Withdrawal Records',
    withdrawal: 'Recharge History',
    recharge: 'Recharge/Withdrawal',
    sys: 'Manage Account',
    merchantInfo: 'Company Details',
    clerk: 'Manage User Accounts',
    adminAccount: 'Manage User Permission',
    secondaryAgent: 'Secondary Agent',
    operator: 'Admin Management',
    exportRules: 'Export Rules Management',
    noticeManager: 'Manage Notice',
    liaisons: 'Manage Contact',
    counter: 'Manage Counter',
    pwdSet: 'Password Setting',
    payType: 'PayType Setting',
    newOrderEmail: 'New order mail notification settings',
    ticketDepot_ticketDepotManager: 'Ticket Manager',
    ticketDepot_stockManager: 'Ticket Stock Manager',
    pdfFiles_stockManager: 'E-ticket Stock Manager',
    operatorWithdrawal_operationAuth: 'Financial Operation Authority',
    operatorWithdrawal_auditAuth: 'Financial Audit Authority',
    auditFlag: 'No Review Required',
    loginNotice: 'Self-travel system function upgrade notice（20170621）',
    recover: 'Reset',
    clear: 'Clear all',
    pageSetting: 'Homepage picture\'s setting',
    productLogList: 'Product modification record',
    popularCities: 'Popular Destinations Management',
    banner: 'Banner Management',
    recommendedAttractions: 'Homepage Recommended'
  },
  login: {
    userLogin: 'User Login',
    rememberLoginStatus: 'Remember Login Status',
    forgetPassword: 'Forgot password?',
    loginIn: 'Log In',
    register: 'Register',
    copyRight: 'Copyright © 2019 Japan Holiday',
    recordInformation: 'Sichuan ICP No.18029410-2',
    recordInformation2: '特定商取引法',
    message1: 'Please Enter Username',
    message2: 'Please enter password',
    message3: 'Please enter the correct password'
  },
  selectMerchantType: {
    imSupplier: 'I am Supplier',
    imDistributor: 'I am Distributor',
    selectType: 'Please select merchant type'
  },
  notice: {
    noticeModify: 'Notice Edit',
    noticeAdd: 'Notice Add',
    noticeTitle: 'Notice Title：',
    noticeContent: 'Notice Content',
    noticeTitlePlaceholder: 'Please enter the notice title',
    validDate: 'Valid Date：',
    DateSelectRange: 'Select Date Range',
    publicationScope: 'Select Range：',
    all: 'All',
    distributor: 'Distributor',
    supplier: 'Supplier',
    pulicationConfirm: 'Pulication Confirm',
    tip: 'Reminder',
    saveOrNot: 'Save or not?',
    notSave: 'Not Save',
    save: 'Save',
    message1: 'The length is 3 to 150 characters',
    message2: 'Please select a valid date',
    message3: 'Please select range',
    message4: 'Give up editing or not?',
    message5: 'The basic information is not complete',
    message6: 'Save Success',
    message7: 'Save Fail',
    message8: 'Delete Fail!',
    message9: 'Delete Success!',
    message10: 'This operation will permanently delete the product,continue or not?',
    message11: 'Merchant selection can\'t be empty!',
    noticeManage: 'Notice Management',
    noticePublication: 'Add Notice',
    noticeTitle1: 'Notice Title',
    search: 'Search',
    index: 'No.',
    title: 'Title',
    publicationScope1: 'Range',
    validDate1: 'Valid Date'
  },
  exportRules: {
    exportRuleTitle: 'Export Rule Management',
    newExportRule: 'Add Export Rule',
    editExportRule: 'Edit Export Rule',
    lableBusinessType: 'Business Type',
    pageType: 'Page Type',
    exportRuleName: 'Export Rule Name',
    exportRuleRemark: 'Export Rule Remark',
    search: 'Search',
    ruleName: 'Rule Name',
    ruleRemark: 'Rule Remark',
    modify: 'Edit',
    delete: 'Delete',
    lable1: 'All',
    lable2: 'Distributor',
    lable3: 'Supplier',
    lable4: 'Products List',
    lable5: 'Order List',
    lable6: 'Carrier',
    lable7: 'Unknown',
    lable8: 'Export Item Setting',
    lable9: 'Remove',
    lable10: 'Add',
    lable11: 'All Items',
    lable12: 'Export Items',
    lable13: 'Write off list',
    message1: 'Sure to delete or not?',
    message2: 'Delete Success',
    message3: 'Basic rules, can\'t be deleted',
    message4: 'Rules in use, can\'t be deleted',
    message5: 'Please enter the export rule name',
    message6: 'Please enter the export rule remark',
    message7: 'Please select merchant type',
    message8: 'Please select page type',
    message9: 'The length is 3 to 100 characters',
    message10: 'The length is 3 to 500 characters',
    message11: 'Sure to reset or not?',
    message12: 'Save Success',
    message13: 'Give up editing or not?',
    button1: 'Submit to save',
    button2: 'Immediately Create',
    button3: 'Reset'
  },
  clerk: {
    clerkTitle: 'Clerk Management',
    addClerk: 'Add Clerk',
    editClerk: 'Edit Clerk',
    account: 'Account',
    name: 'Name',
    telphone: 'Telphone',
    emailAddress: 'E-mail',
    clerkAccount: 'Clerk Account',
    clerkName: 'Clerk Name',
    clerkPwd: 'Clerk Password',
    confirmPwd: 'Confirm Password',
    clerkTel: 'Clerk Telphone',
    message1: 'Clerk Account/Name',
    message2: 'Please select roles',
    message3: 'Sure to delete or not?',
    message4: 'Delete Success',
    message5: 'Set Success',
    message6: 'Please enter the clerk\'s account',
    message7: 'Account should be formed from letters, digits, underba, delimiters, and begin with a letter',
    message8: 'Please enter the cleck\'s name',
    message9: 'The cleck name can\'t be empty',
    message10: 'Please enter the cleck\'s password',
    message11: 'Please enter 6-16 upper and lower case letters or digits',
    message12: 'Must be consistent with the input above',
    message13: 'Please enter the cleck\'s phone number',
    message14: 'Please enter the cleck\'s E-mail',
    message15: 'You can receive system information by E-mail',
    message16: 'The length is 3 to 50 characters',
    message17: 'Please enter the correct password',
    message18: 'The length is 6 to 16 characters',
    message19: 'Please enter the correct password',
    message20: 'Submit the save or not?',
    message21: 'Save Success',
    message22: 'Please enter the account',
    message23: 'The length is 6 to 30 characters',
    message24: 'Please enter the correct account',
    message25: 'The user name already exists',
    message26: 'Please enter the password again',
    message27: 'The two passwords differ',
    message28: 'The length is 5 to 50 characters',
    message29: 'Please enter the correct E-mail',
    message30: 'E-mail already registered',
    message31: 'The length is 6 to 20 characters',
    message32: 'Please enter the correct phone number',
    message33: 'Give up editing or not?',
    lable1: 'Role',
    lable2: 'Move',
    lable3: 'Add',
    lable4: 'Role List',
    lable5: 'Added Role'
  },
  merchant: {
    merchantInfo: 'Merchant Info',
    distributorManage: 'Distributor Management',
    supplierManege: 'Supplier Management',
    all: 'All',
    waitAudit: 'Wait Audit',
    auditPass: 'Audit Pass',
    auditNG: 'Audit Fail',
    auditNG2: 'Audit Unpass',
    auditNGReason: 'Edit the reason for auditing Unpass',
    searchContent: 'Merchant Name/ID',
    businessName: 'Merchant Name',
    createDate: 'Application Date',
    auditStatus: 'Status',
    auditUserName: 'Auditor',
    lableTodo: 'Todo',
    lableWatch: 'Watch',
    lableAuth: 'Role',
    lableExpSet: 'Export Setting',
    accountInfo: 'Account Info',
    loginAccount: 'Login Account',
    companyName: 'Company Name',
    companyLogo: 'Company Logo',
    legalRepresentative: 'Legal Person',
    companyAddress: 'Company Add.',
    companyTelephone: 'Company Tel.',
    companyWebsite: 'Web/Store Link',
    companyEmail: 'Company E-mail',
    bankCardNumber: 'Bank account',
    qualificationPath: 'Qualification',
    location: 'Location',
    baseInfo: 'Company Info',
    directorInfo: 'Business Leader Info',
    directorName: 'Name',
    directorPosition: 'Position',
    directorEmail: 'E-mail',
    directorTelephone: 'Telephone',
    directorWechat: 'Wechat ID',
    directorCardPath: 'Business Card',
    setAuthAuditPass: 'Set previlege and verify accessbility',
    selectAuth: 'Please choose the Role',
    message1: 'Please choose the Role',
    message2: 'Export setting',
    message3: 'Export the type of page',
    message4: 'Export settings for product',
    message5: 'Export settings for oder',
    message6: 'Export rules',
    message7: 'Please choose the export rules',
    message8: 'Please choose the export type of page',
    message9: 'Please choose the export rules',
    message10: 'Set successfully',
    message11: 'The unique ID in business system for user identification)',
    message12: 'Distribution Summary',
    message13: 'Order amount',
    message14: 'Order account',
    message15: 'Ticket amount',
    message16: 'Account balance status',
    message17: 'Account balance',
    message18: 'View account history',
    message19: 'Charge/Withdraw history',
    message20: 'Process success',
    message21: 'Process fail',
    message22: 'Quit audit',
    message23: 'Quota setting',
    message24: 'Write off export item settings',
    lable1: 'Delete',
    lable2: 'Add',
    lable3: 'Role list',
    lable4: 'Added role',
    yayaPaySet: 'Pin ticket account set',
    easyGoUser: 'Supplier Account',
    yayaPayUser: 'Pin ticket account',
    pleaseEnterYayaPayUser: 'Please enter pin ticket account.',
    pleaseEnterLessTen: 'Bind at most ten accounts!',
    lengthMustLess100: 'Account length should be less than or equal to 100!',
    yayaAccountHadExists: 'The pin ticket account had existed, adding fail.',
    yayaAccountExists: 'The pin ticket account is repeated, please re-enter.',
    enableSwitch: 'Enable Switch',
    lineOfCredit: 'Line Of Credit',
    creditDate: 'Credit Date'
  },
  merchantInfo: {
    merchantInfo: 'Company Info',
    merchantInfoEdit: 'Edit company info',
    auditNG: 'Audit denied',
    accountInfo: 'Account Info',
    auditStatus: 'Audit status',
    loginAccount: 'Login Account',
    location: 'Location',
    baseInfo: 'Company Info',
    companyName: 'Company Name',
    companyLogo: 'Company logo',
    legalRepresentative: 'Legal Person',
    companyAddress: 'Company Add.',
    companyTelephone: 'Company Tel.',
    companyWebsite: 'Web/Store Link',
    companyEmail: 'Company E-mail',
    bankCardNumber: 'Bank account',
    qualificationPath: 'Qualification',
    supplierSummary: 'Distribution Summary',
    orderTotal: 'Order amount',
    orderTotalPay: 'Order account',
    ticketTotal: 'Ticket amount',
    accountBalanceInfo: 'Account balance status',
    accountBalance: 'Account balance',
    seeBusinessLog: 'View account history',
    seeRechargeLog0: 'View charge/withdraw history',
    seeRechargeLog1: 'View withdraw history',
    directorInfo: 'Business Leader Info',
    directorName: 'Name',
    directorPosition: 'Position',
    directorEmail: 'E-mail',
    directorTelephone: 'Telephone',
    directorWechat: 'Wechat ID',
    directorCardPath: 'Business Card',
    submitAudit: 'Submit audit',
    submitEdit: 'Submit edit',
    notSave: 'Not save',
    save: 'Save',
    message1: '(The unique ID in business system for user identification)',
    message2: 'Please confirm the account info is correct',
    message3: 'Save edit?',
    message4: 'Please select country',
    message5: 'Please enter company official name',
    message6: 'Length limited within 6 to 200',
    message7: 'Please upload company Logo',
    message8: 'Please enter company\'s legal person',
    message9: 'Length limited within 2 to 200',
    message10: 'Please enter company detailed address',
    message11: 'Length limited within 10 to 200',
    message12: 'Please enter company\'s telphone',
    message13: 'Please enter correct phone number',
    message14: 'Length limited within 6 to 20',
    message15: 'Please enter company\'s email address',
    message16: 'Please enter correct email address',
    message17: 'Length limited within 7 to 50',
    message18: 'Please enter company\'s official website',
    message19: 'Length limited within 4 to 50',
    message20: 'Please enter company\'s bank account',
    message21: 'Please enter correct bank account',
    message22: 'Length limited within 4 to 5',
    message23: 'Please upload company\'s official qualification',
    message24: 'Please enter business leader\'s name',
    message25: 'Length limited within 2 to 50',
    message26: 'Please enter telephone',
    message27: 'Please enter correct telephone',
    message28: 'Please enter position',
    message29: 'Please enter wechat ID',
    message30: 'Length limited within 6 to 50',
    message31: 'Please enter business leaser\'s card',
    message32: 'Submit edit？',
    message33: 'Edit successfully',
    message34: 'Edit failed',
    message35: 'Please enter email address',
    message36: 'Length limited from 5 to 50',
    message37: 'Please enter correct email address',
    message38: 'Email address used'
  },
  secondaryAgent: {
    secondaryAgentTitle: 'Secondary Agent',
    message1: 'Please enter name',
    search: 'Search',
    name: 'Name',
    time: 'Registration time',
    remark: 'Remark',
    label: 'Unbind',
    addCode: 'Generate invitation code',
    copySuccess: 'Copy successfully',
    copyError: 'Copy failed',
    operator: 'Edit remark',
    remarkTip: 'Please enter remark',
    message2: 'Edit successfully',
    message3: 'Edit failed',
    message4: 'Unbind successfully',
    message5: 'Unbind failed'
  },
  errorMsg: {
    user: {
      noAuth: 'User permission unavailable, please contact administrator',
      systemMsg: 'System error',
      noUserOrPassword: 'Account not exists or wrong password ',
      setUsernameOrPassword: 'Please enter account and password'
    }
  },
  operator: {
    jtrOrderReimburse: 'One side cancellation of system',
    operatorManege: 'Administrator Manage',
    addOperator: 'Add administrator',
    updateOperator: 'Edit administrator',
    updatePwd: 'Password',
    updateInfo: 'Edit',
    auth: 'Role',
    searchText: 'Administrator account/name',
    account: 'Account',
    name: 'Name',
    opearate: 'Operation',
    opeAccount: 'Administrator account',
    opeName: 'Administrator name',
    opePwd: 'Password',
    opeNewPwd: 'New administrator password',
    checkPwd: 'Confirm password',
    lable1: 'Delete',
    lable2: 'Add',
    lable3: 'Role list',
    lable4: 'Added role',
    message1: 'Please select roles',
    message2: 'Are you sure to delete？',
    message3: 'Delete successfully',
    message4: 'Set up successfully',
    message5: 'Please enter administrator account',
    message6: 'Only letter,num, underbar,partition can be used for account, and letter should be put in the first',
    message7: 'Please enter administrator name',
    message8: 'Administrator name should not be blank',
    message9: 'Please enter password',
    message10: 'Please enter case letters or numbers at the length of 6-16',
    message11: 'Must be same with the above',
    message12: 'Length limited within 1 to 50',
    message13: 'Length limited within 6 to 16',
    message14: 'Please enter correct password',
    message15: 'Are you sure to save？',
    message16: 'Save successfully',
    message17: 'Please enter account',
    message18: 'Length limited within 6 to 30',
    message19: 'Please enter correct account',
    message20: 'User name existed',
    message21: 'Please enter password again',
    message22: 'The password is not the same！',
    message23: 'Are you sure to abandon edit？'
  },
  product: {
    rule_0_500: 'Length limited within 0 to 5000',
    rule_0_5000: 'Length limited within 0 to 5000',
    rule_1_200: 'Length limited within 1 to 200',
    rule_1_2000: 'Length limited within 1 to 2000',
    rule_1_500: 'Length limited within 1 to 500',
    rule_0_200: 'Length limited within 0 to 200',
    rule_0_2000: 'Length limited within 0 to 2000',
    rule_0_50: 'Length limited within 0 to 50',
    rule_0_1_500: 'Length limited within 0 to 500',
    rule_1_50: 'Length limited within 1 to 50',
    rule_0_20: 'Length limited within 0 to 20',
    rule_n1_2: 'Length limited within 1 to 2',
    rule_n1_4: 'Length limited within 1 to 4',
    rule_n1_6: 'Length limited within 1 to 6',
    rule_n0_2: 'Length limited within 0 to 2',
    rule_n0_5: 'Length limited within 0 to 5',
    rule_n0_6: 'Length limited within 0 to 6',
    rule_mail: 'Please enter the message content',
    integer_1: 'Please enter integer',
    integer_2: 'Please enter positive integer',
    selDate: 'Select date',
    back: 'Return',
    ticketType_1: 'Auto-issue from linked ticket vault',
    ticketType_3: 'Manual voucher upload within order',
    ticketType_4: 'System-generated EasyGo vouchers',
    choose_sys: 'Choose System：',
    chooseDepot: '选择仓库',
    baseInfo: 'Base info',
    content: 'Product content',
    priceSet: 'Set price',
    reserveSet: 'Set reservation',
    saveDraft: 'Save to draft',
    preview: 'Preview',
    submitCheck: 'Submit audit',
    submitAuditAndPass: 'Submit audit and pass',
    isExitProduct: 'Quit product editing?',
    isSaveDraft: 'Save draft？',
    noSave: 'Don\'t save',
    save: 'Save',
    add: 'Add',
    edit: 'Edit',
    product_0: 'Product(electronic ticket)',
    product_1: 'Product(ticket)',
    product_2: 'Product(experience)',
    product_3: 'Product(one day tour/long period tour)',
    product_4: 'Produc(WIFI)',
    product_5: 'Product(SIM Card)',
    product_6: 'Product(restaurant)',
    product_7: 'Product(traffic)',
    product_8: 'Product(set)',
    doNotSave: 'No update content, don\'t need to save',
    reqMsg_1: 'Congratulations，audit submitted',
    reqMsg_2: 'Congratulations，save successfully',
    reqMsg_3: 'Sorry，failed to submit audit！',
    reqMsg_4: 'Sorry，failed to save！',
    reqMsg_5: 'Save，false audit submission，please retry',
    reqMsg_6: 'Sorry，failed to save，please retry',
    reqMsg_7: 'This set is without subproduct！',
    reqMsg_8: 'Congratulations, it has been approved.',
    reqMsg_9: 'Sorry, the audit failed!',
    reqMsg_10: 'Sorry, the audit error, please try again!',
    reqMsg_11: 'Product import failed, please try again. ',
    reqMsg_12: 'Product ID has been bound，please re-enter.',
    reqMsg_13: 'This product is not in stock at this time and cannot be imported.',
    fileDepot_no: 'Please select a file repository',
    baseInfo_no: 'Base info is not completed',
    content_no: 'Product info is not completed',
    reserveSet_no: 'Setting reservation is not completed',
    explain01: 'Name combined with:address+product name+amount+name for another product+amount+special，eg“BeijingShunjing Hot spring(fish spa contained)2 tickets+Nanshan Skiing(Electronic ticket)2”',
    explain02: 'Key word below product\'s title',
    explain03: 'Distributors invisible，easy for supplier searching product',
    explain04: 'Adult（above 18），student（12~17），child，baby，couple',
    productName01: 'Set name：',
    productName02: 'Name：',
    qrCodeName: 'Qr Code name',
    productName_placeholder: 'Please enter product name',
    qrCodeName_placeholder: 'Please enter qr Code name',
    productPrice_placeholder: 'Please enter product offset price',
    productMin_Price_placeholder: '请输入产品最低价格',
    errorProductConfirmType1: 'The sub product includes the secondary confirmation product. Only manual confirmation can be selected for order confirmation',
    errorProductConfirmType2: 'The sub product does not include the secondary confirmation product. Only automatic confirmation can be selected for order confirmation',
    errorProductConfirmType3: 'The reservation confirmation method cannot be changed because the product is included in the set product.',
    orderNum_placeholder: '请输入排序',
    productHighlights01: 'Set highlight：',
    productHighlights02: 'Highlight：',
    productHighlights_placeholder: 'Please highlight product',
    productInsideRemark: 'Inside remark：',
    productInsideRemark_placeholder: 'Please enter inside remark',
    scenicSpot: 'Spot：',
    ticketType: 'Ticket type：',
    ticketType_placeholder: 'Please enter ticket type',
    productSaleDate: 'Product online period：',
    productSaleDate_placeholder: 'Please select time on sale',
    categoryLabel: 'Category Label：',
    categoryLabel_placeholder: 'Please enter category label, press Enter to confirm',
    belongCity: 'Belong City：',
    belongCity_placeholder: 'Please select belong city',
    chooseDepot_rule: '请选择仓库',
    productName_rule: 'Please enter product name',
    scenicSpotArr_rule: 'Please select at least one spot',
    scheduleDuration: 'Duration：',
    scheduleDuration_placeholder: 'Please enter journey duration',
    imageExplain: 'Image info：',
    uploadBtn: 'Click to upload',
    videoExplain: 'Video info：',
    productPackageDetail: 'Set detailes：',
    mealTimeInterval: 'Meal time：',
    mealTime_1: 'No limitation',
    mealTime_2: 'Breakfast',
    mealTime_3: 'Lunch',
    mealTime_4: 'Afternoon tea',
    mealTime_5: 'Supper',
    mealTime_6: 'Evening dish',
    mealNumber: 'No. of meal：',
    mealNumber_1: 'Meal for single',
    mealNumber_2: 'Meal for double',
    mealNumber_3: 'Meal for 3~4 people',
    mealNumber_4: 'Meal for 5~10 people',
    mealNumber_5: 'Meal for more than 10 people',
    mealDetail01: 'Name',
    mealDetail01_placeholder: 'Please enter set name',
    mealDetail02: 'Content',
    mealDetail03: 'No.',
    mealDetail04: 'Name',
    mealDetail05: 'Amount',
    mealDetail06: 'Photo',
    mealDetail07: 'Multiply',
    mealDetail07_del: 'Delete',
    mealDetail07_up: 'Up',
    mealDetail07_down: 'Down',
    up_msg: 'This is the head',
    down_msg: 'This is the end',
    mealDetail07_add: 'Add row',
    md_delGroup: 'Delete group',
    md_addGroup: 'Add group',
    md_validMsg: 'The set info is not complete',
    md_addMsg: 'Max add row is 20！',
    md_addMsg1: 'Max add group is 10！',
    useTime: 'Use time：',
    useTime_1: 'Unlimited',
    useTime_2: 'Detailed time',
    editorProductDetail: 'Detailes：',
    viewAddress: 'Address：',
    viewAddress_placeholder: 'Please enter spot address',
    businessTime: 'Business time：',
    businessTime_placeholder: 'Please enter business time',
    productPeople_placeholder: 'Please enter fit people',
    exclusive: 'Vehicle specific identification：',
    exclusive_1: 'Non special purpose vehicle',
    exclusive_2: 'Male vehicles',
    exclusive_3: 'Women\'s vehicles',
    lang: 'Service lang：',
    lang_1: 'Chinese',
    lang_2: 'English',
    lang_3: 'Japanese',
    lang_4: 'Korean',
    productTraffic: 'Traffic way：',
    productTraffic_placeholder: 'Enter the traffic way',
    networkFlow4g: '4G network：',
    networkFlow4g_placeholder: 'Enter 4G network traffic',
    networkFlow3g: '3G network：',
    networkFlow3g_placeholder: 'Enter 3G network traffic',
    networkCoverage: 'Coverage：',
    networkCoverage_placeholder: 'Enter the network coverage',
    wifiAccessories: 'ACCY：',
    wifiAccessories_placeholder: 'Enter ACCY',
    simSize: 'SIM size：',
    simSize_placeholder: 'Enter SIM size',
    pathType: 'Path type：',
    pathType_1: 'Group tour',
    pathType_2: 'Chartered tour',
    pathType_3: 'airport transfer',
    traffic: 'Transportation：',
    traffic_1: 'Automobile',
    traffic_2: 'Train',
    traffic_3: 'Cruise',
    groupNumber: 'No. of people：',
    groupNumber_placeholder: 'Enter the number of people',
    shoppingType: 'Shopping info：',
    shoppingType_1: 'Non purchase',
    shoppingType_2: 'Incl purchase',
    scheduleInfo: 'Itinerary：',
    productCostInclude: 'Fee include：',
    productCostInclude_placeholder: 'Enter expense items',
    productCostExclusive: 'Fees exclude：',
    productCostExclusive_placeholder: 'Enter the items not covered',
    productUseFlow: 'How to use：',
    productUseFlow_placeholder: 'Enter the procedure',
    productSupplementPath: '使用流程补充',
    userNote: 'Instructions for use：',
    userNote_placeholder: 'Enter the Instructions for use',
    importantNote: 'Important hints：',
    importantNote_placeholder: 'Enter the Important hints',
    editorFreeItem: 'Free items：',
    newProductPackageDtoList_rule: 'At least one package detail is required',
    scheduleInfoDtoList_rule: 'At least one itinerary is required',
    reserveLimitDay: 'Booking deadline：',
    rld01: ' ',
    rld02: 'days',
    rld03_placeholder: 'Time',
    rld04: 'o’clock before. (Japan standard time)',
    confirmHour: 'Confirm type：',
    confirmHour_1: 'Instant confirm',
    confirmHour_2: 'Manually confirm',
    ch01: 'Duration For Re-check：',
    ch02: 'Japan business day working hour',
    ch03: '小时（自然时长）',
    maxReserveNummber: 'Max per order：',
    minReserveNummber: 'Min per order：',
    mrn_explain: '\'0\' for no limit',
    orderValid: 'Ticket valid duration：',
    ov01: 'Valid only on specified use date',
    ov02: 'From purchasing date',
    ov03: 'From purchasing date to specified date',
    ov04: 'From specified use date',
    ov05: 'From specified use date to specified date',
    ov06: 'Specified date',
    ov07: 'On specified use date',
    orderRefund: 'Change & refund：',
    orderRefund_1: 'No change & refund',
    orderRefund_2: 'Flexible',
    orderRefund_tip: '1. The cutoff time is 23:59:59 on the specified day.\n2. Example: If the departure date is January 3, cancellations made before January 2 are free of charge,\n while cancellations made on January 2 or January 3 are subject to a 100% cancellation fee. The settings are as follows:\n0 day(s) before the order validity cutoff time (including the current day), the change/cancellation fee: 100%\n2 day(s) before the order validity cutoff time (including the current day), the change/cancellation fee: 100%\n3 day(s) before the order validity cutoff time (including the current day), the change/cancellation fee: 0%',
    orderRefund_3: 'Change/refund with fee',
    refundDescription: 'Additional policy details：',
    rdi_placeholder: 'Change/refund policies',
    customerData: 'Required guest information：',
    customerData_1: 'All guest(s) info required',
    customerData_2: 'Guest(s) representative info required',
    mustFillInInf: 'Required guest info：',
    mustFillInInf_1: 'Name',
    mustFillInInf_2: 'Mobile',
    mustFillInInf_3: 'Wechat',
    mustFillInInf_4: 'Passport number',
    mustFillInInf_5: 'Gender',
    mustFillInInf_6: 'Ticket use date',
    mustFillInInf_7: 'Ticket collection date',
    mustFillInInf_8: 'Passenger family name',
    mustFillInInf_9: 'Passenger first name',
    mustFillInInf_10: 'Passenger phone number',
    mustFillInInf_11: 'Passenger email',
    mustFillInInf_12: 'Passenger gender',
    mustFillInInf_13: 'Passenger age',
    mustFillInInf_14: 'Emergency contact number',
    mustFillInInf_15: 'Passenger type',
    mustFillInInf_16: '同行者',
    customItem: 'Add item',
    ci01: 'Item',
    ci01_placeholder: 'Item name',
    ci02: 'Requirement',
    ci02_placeholder: 'Select',
    ci02_1: 'Optional',
    ci02_2: 'Required',
    ci03: 'Instructions',
    ci03_placeholder: 'Instructions',
    ci04: 'Action',
    ci04_del: 'Delete',
    ci05: 'Add customized item',
    editorNotice: 'Notice for book：',
    orderLiaison: 'Order contact：',
    emergencyLiaison: 'Urgent contact：',
    validateAuthority: 'Verify authority：',
    receiveCounter01: 'Receive counter：',
    receiveCounter02: 'Counter For Paper Ticket Pick-up：',
    returnCounter: 'Return counter：',
    reserveLimitDay_rule: 'Please enter reservation time limit',
    reserveLimitDay_rule1: 'In 99 days',
    reserveLimitDay_rule2: 'Please enter the time',
    orderDayNotMore: 'Not later than 99 days from order date',
    trip01: 'The',
    trip02: 'Day',
    trip03: 'Itinerary：',
    trip04: 'Add new itinerary',
    trip05: 'Add one day',
    trip06: 'Time Range：',
    trip06_placeholder: 'Select time range',
    trip06_phBegin: 'Start time',
    trip06_phEnd: 'End time',
    trip07: 'Destination：',
    trip07_placeholder: 'Destination & departure time?',
    trip08: 'Detail：',
    trip08_placeholder: 'E.g.:The destination for which day? How to get there?  Attractions and culture?',
    trip09: 'Images：',
    trip09_btn: 'Upload',
    trip10: 'Save Itinerary',
    trip_msg1: 'No itinerary is selected',
    trip_msg2: 'Days, itinerary',
    tripRange_rule: 'Please set time range',
    trip_interval_rule: 'Please enter end time and start time',
    groupContentTitle_rule: 'Please enter destination',
    groupContent_rule: 'Please enter itinerary details',
    imageList_rule: 'Please select images for itinerary',
    trip_msg3: 'Please select an itinerary then save!',
    trip_msg4: 'Congratulation, save succeed',
    price01: 'Stock & price',
    price02: 'Time range-',
    price03: 'Add time range',
    price04: 'Delete',
    price05: 'Time range',
    price06: 'Select time range',
    price061: 'Time range can`t be overlapped',
    price07: 'Procurement price',
    price08: 'Please enter procurement price',
    price09: 'EasyGo price',
    price10: 'Please enter distribution price',
    price11: 'Market price',
    price12: 'Please enter market price',
    price13: 'Stock',
    price14: 'Please enter stock',
    price15: 'Piece',
    price16: 'Save',
    price17: 'Reset',
    price18: 'Date range can`t be empty',
    price19: 'Time range can`t be empty',
    price20: 'Date range',
    price21: '円',
    price22: 'EasyGo supplier price',
    price23: 'Please enter EasyGo supplier price',
    price24: 'Recommended retail price',
    price25: 'Retail price',
    price26: 'Add Ticket class',
    price27: 'Ticket class',
    price28: 'Price category',
    price29: 'Price class-',
    price30: 'Price class',
    price31: 'Please enter the total stock of the price category',
    price32: 'The total inventory shall be greater than the usage',
    price33: 'Total inventory should be greater than 0',
    price34: 'Please enter price type (Japanese): 大人、小児、身障者大人、 身障者小児. ',
    price_msg1: 'Please select date first',
    price_msg2: 'Time range-',
    price_msg3: 'Not saved',
    price_msg4: 'Please select date and time range first',
    price_msg5: 'Save succeed',
    price_msg6: 'Save fail',
    price_msg7: 'Delete succeed',
    price_msg8: 'Delete fail',
    price_msg9: 'Can add at most 50 records',
    price_msg10: 'The selected item can\'t be empty',
    price_msg11: 'All current data would be replaced for this period when submitted. Sure to save?',
    price_msg12: 'All data would be deleted for “',
    price_msg13: '” when confirmed, Confirm to delete it?',
    price_msg14: 'All existing data of this price category will be overwritten. Please confirm whether to save or not.',
    price_msg15: 'Confirm that all data of this price category will be deleted, please confirm whether to delete?',
    price_msg16: 'This price category is in use and cannot be removed',
    price_msg17: 'The product already has the same price category, save failed',
    refund01: '',
    refund02: 'days before the order validity cutoff time (including the current day), the change/cancellation fee: ',
    refund03: 'Remove',
    refund04: 'Add new rule',
    refund05: 'Change/refund fee：',
    counter01: 'Select counter',
    counter02: 'Counter',
    counter03: 'Addr',
    counter04: 'Tel',
    counter05: 'Business hours',
    liaison01: 'Select contact',
    clerk01: 'Select a Salesperson',
    clerk02: '账号',
    clerk03: '业务员',
    clerk04: 'Contact number',
    clerk05: '邮箱',
    liaison02: 'Contact',
    liaison03: 'Contact way',
    liaison04: 'Reception time',
    spot01: 'Select relevant attractions',
    spot02: 'Select scenic spot',
    spot03: 'Cancel',
    spot04: 'Confirm',
    takeP01: 'Pick product from repository',
    takeP02: 'Must select one sub-product before save or submit your package',
    takeP03: 'No.',
    takeP04: 'Title',
    takeP05: 'Procurement price',
    takeP06: 'Distribution price',
    takeP07: 'Market price',
    takeP08: 'Amounts',
    takeP09: 'Action',
    takeP10: 'Reference',
    takeP11: 'Pick product from repository',
    takeP12: 'Delete',
    takeP13: 'Ticket class',
    takeP14: 'Vehicle specific identification',
    stockNumber01: 'The inventory',
    stockNumber02: 'Use the number',
    stockNumber03: 'disable',
    stockNumber04: 'enable',
    priceTypeHistory01: 'Check the record',
    priceTypeHistory02: 'inventories increased by',
    priceTypeHistory03: 'Inventory is down by',
    upload01: 'Only files in jpg/png/jpeg/gif format and size not more than {0}MB can be uploaded',
    upload02: 'Maximum size is 20MB for video upload',
    upload03: 'Maximum numbers for uploads',
    upload04: 'Pics!',
    upload05: 'Videos!',
    upload06: 'The image format is not valid!',
    upload07: 'Can`t upload image more than {0}MB!',
    upload08: 'The file name can`t contain comma!',
    upload09: 'The video format is not valid!',
    upload10: 'Can`t upload video more than 20MB!',
    upload11: 'Upload failed!',
    upload12: 'File upload error!',
    upload13: '请提供实体票·柜台·接待设施外观的照片',
    upload14: 'A file',
    upload15: 'The size of the uploaded file cannot exceed 5MB！',
    calendar01: '/',
    calendar02: '',
    calendar03: 'Select all the inventories of current month',
    calendar04: 'Piece',
    clerkTable01: 'By default all salesmen are verifiable',
    week_1: 'Mon.',
    week_2: 'Tues.',
    week_3: 'Wed.',
    week_4: 'Thur.',
    week_5: 'Fri.',
    week_6: 'Sat.',
    week_7: 'Sun.',
    explain_1: 'Procurement Price: the price in which be sold to platform(purchase price), the unit price supplier request payout from platform regularly',
    explain_2: 'Distribution Price: the price in which platform sales to travel agencies(distributors)',
    explain_3: 'The profit of platform is the difference between procurement price and distribution price',
    explain_4: '说明："0"代表无库存',
    explain_5: '分销平台采购价：EASYGO系统售卖给其他分销平台的价格，与采购价的差额是平台的利润。',
    explain_6: '市场价：一般市场参考售价',
    explain_7: '零售价：建议分销商设定的BtoC售价',
    explain_8: 'Price type (Japanese) details:',
    explain_9: 'Adult fare',
    explain_10: 'Child fare',
    explain_11: 'Disabled adult charge',
    explain_12: 'Handicapped children fee',
    explain_13: '(only supports: 大人、小児、身障者大人、 身障者小児. Other price types will not be processed. )',
    explain_14: '(Please set the product inventory according to the available date of the respective price type. Unavailable dates will not be processed even if set. Purchase price will not be processed even if set)',
    explain_15: 'Valid period：',
    explain_16: 'No date available for current price type. ',
    explain_17: 'On sale or not',
    explain_18: 'Price rule setting description：',
    explain_19: '乐天产品价格及日期填写说明：',
    explain_20: '请根据可用日期进行设置，设置不可用日期不生效，采购价不生效',
    isSale: 'On sale',
    notSale: 'Not on sale',
    productDeleteMessage: 'Please delete the package first, or remove the product from the package!',
    none: 'none',
    sendMailSet: 'Advance delivery day：',
    mailContent: 'Email content：',
    noSend: 'Don not send',
    mailTime: 'Before date',
    mailContent_placeholder: 'Please enter the message content',
    mailsetTips: 'Only e-tickets without PDF are supported'
  },
  recharge: {
    depositWithdraw: 'Recharge/Withdraw',
    depositWithdrawHistoryRecord: 'History of recharge/Withdraw',
    searchStr: 'Shop name/ID：',
    placeholder1: 'Please enter shop name/ID',
    businessType: 'Shop type：',
    businessType1: 'Shop type',
    placeholder2: 'Please select',
    search: 'Search',
    businessName: 'Shop name',
    businessName1: 'Shop name：',
    balance: 'Balance',
    accountBalance: 'Account balance：',
    operation: 'Operation',
    deposit: 'Manual recharge',
    depositAuto: 'Online recharge',
    automatic: 'automatic',
    withdraw: 'Withdraw',
    record: 'Record',
    withdrawAvail: 'Available amount：',
    withdrawAmount: 'Withdraw Amount：',
    withdrawRemark: 'Withdraw remark：',
    cancel: 'Cancel',
    submit: 'Submit for audit',
    depositAmount: 'Recharge amount：',
    depositRemark: 'Recharge remark：',
    all: 'All',
    supplier: 'Supplier',
    distributor: 'Distributor',
    submitSuccess: 'Submit succeed',
    subimitFailed: 'Submit fail',
    message: 'More than the amount you can withdraw!',
    goBack: 'Return',
    dateRange: 'Time range：',
    placeholder3: 'Select date range',
    date: 'Date',
    operator: 'Operator',
    type: 'Type',
    supplierWithdraw: 'Withdraw request of merchants',
    platformWithdraw: 'Operator withdraw',
    operationAmount: 'Amount',
    remark: 'Comment',
    lastWeek: 'In the latest week',
    lastMonth: 'In the latest month',
    lastThreeMonth: 'In the latest 3 months',
    message2: 'Recharge amount should be positive integer!',
    message3: 'Withdraw amount should be positive integer!',
    message4: 'Recharge amount should be positive integer and less than 2000,000,000!'
  },
  order: {
    batchSummary: 'Batch details',
    canBeUseStartDate: 'Start date',
    canBeUseEndDate: 'End date',
    createUserName: 'creator ',
    bulkPurchase: 'Bulk purchase',
    remarks: 'remarks',
    orderSource0: 'ToB',
    orderSource1: 'SupplierToC',
    orderSource2: 'External API',
    orderSource3: 'JTR',
    orderSource4: 'KLOOK',
    orderSource5: 'Easygo',
    orderSource6: 'KKday',
    orderSource7: 'CKMap',
    orderSource8: 'DistributorToC',
    orderSource9: 'LINK',
    toCDistributorName: 'EasyGo BtoC',
    submitTime: 'Booking time',
    sourceType: 'Order source',
    sourceJtr: 'Supplier',
    sourceJph: 'JPH Supplier',
    allDate: 'Date',
    productPrice: 'productPrice',
    totalPrice: 'Total(JPY)',
    orderInfo: 'Order info',
    newSourceJtr: '运营者订单',
    payTime: 'Pay time',
    productUseDate: 'Participation Date',
    cancelTime: 'Cancel date',
    keyWorld: 'Keyword',
    distributor: 'Distributor',
    secondAgentId: 'Distributor ID',
    secondAgentCommission: 'Distributor Revenue',
    productArea: 'Product area',
    supplier: 'Supplier',
    search: 'Search',
    synchronousTime_01: '（Data update time：',
    synchronousTime_02: '）',
    synchronousOrder_01: 'Update',
    synchronousOrder_02: '(',
    synchronousOrder_03: 's)',
    validateTime: 'Verify date',
    validateDate: 'Ticket valid date',
    expirationTime: 'Expiration time',
    timeSlot: 'Select time range for search',
    searchMsg: 'Order ID/Product name/Customer name/Customer email',
    channelOrderId: 'Channel ID',
    searchDistributor: 'Please enter distributor name',
    searchSupplier: 'Please enter supplier name',
    orderExport: 'Export order',
    ticketDepotExport: 'Download warehouse list',
    ticketBatchDetailExport: 'Download batch details list',
    productExport: 'Export product',
    productExports: 'Export product list',
    orderId: 'Order ID',
    sonOrderId: '子订单号',
    productName: 'Product name',
    allBuyQuantity: 'Quantity',
    customerName: 'Customer',
    orderExplain: 'Remarks',
    orderExplain1: 'Remarks (for own company\'s accounts)',
    orderStatus: 'Status',
    notPay: 'Unpaid',
    beConfirm: 'Wait for confirm',
    beingCancel: 'Canceling',
    haveCanceled: 'Canceled',
    haveConfirmed: 'Confirmed',
    beTicket: '待出票',
    batchHaveDone: 'Purchased',
    haveDone: 'Finish',
    haveCancel: 'Canceled',
    haveRefundRequest: '已申请退款',
    haveRefund: 'Refunded',
    havePay: 'Paid',
    failedPay: '支付失败',
    refuseRefund: '拒绝退款',
    haveTicket: 'Comfirmed',
    notPayButCanceled: 'Unpaid & Canceled',
    haveExpired: 'Expired',
    leftHandleTime: 'Processing time',
    operation: 'Operation',
    addOrSub: 'Partial cancellation',
    refund: 'refund',
    beAdd: 'Order addition',
    addOrSubOrRefund: 'Partial cancellation / refunds',
    source: 'soruce',
    validateOrder1: 'Authentication is successful',
    validateOrder2: 'You are not authorized to validate this order',
    validateOrder3: 'Validation fails',
    validateOrder4: '',
    date_empty: 'Invalid date.',
    myouji_kana_empty: 'Invalid family name (hiragana) format.',
    namae_kana_empty: 'Invalid first name (hiragana) format.',
    bin_key_id_empty: 'Invalid product ID，Please re-enter',
    sex_empty: 'Invalid gender format. ',
    tel_empty: 'The format of mobile phone is incorrect, please input 10-11 digits',
    email_empty: 'The email format is incorrect. Please enter the correct email',
    total_num_empty: 'Invalid age parameter. ',
    age_empty: 'Age format is incorrect, please enter a number',
    emergency_phone_empty: 'Invalid emergency contact number format. ',
    ctype_empty: 'Invalid age / disability parameter. ',
    recep_empty: 'Reception has ended. ',
    num_over: 'Insufficient tickets.',
    num_not_sale: 'The selected specified date has not been put on sale',
    r_id_empty: 'Specified reservation ID has already been cancelled. ',
    r_id_already_cancel_ok: 'Specified reservation ID has already been cancelled. ',
    r_id_already_payment_ok: 'Order payment completed. ',
    thirdMethodErr: 'Connection error occurred, please contact administrators. ',
    systemErr: 'System error, please contact administrators. '
  },
  jtrOrder: {},
  withdrawal: {
    withdrawalCash: 'Recharge/withdraw',
    withdrawalCashManager: 'Recharge/Withdraw Management',
    withdrawalOnline: 'Online recharge',
    withdrawalOffline: 'Manual recharge',
    applyWithdraw: 'Submit for withdraw',
    beingHandel: 'Pending',
    beingAudit: 'Wait for audit',
    notPass: 'Audit Fail',
    selectTimeSlot: 'Select Date',
    selectDateSlot: 'Please select date',
    createTime: 'Created on',
    operationPeople: 'Operator',
    type: 'Type',
    recharge: 'Recharge',
    withdraw: 'Withdraw',
    withdrawAmount: 'Withdraw amount',
    rechargeWithdrawAmount: 'Amount',
    rechargeWithdrawAmount2: 'Amount',
    remark: 'Notes',
    refundReason: 'Failure reason',
    accountBalance: 'Account balance',
    canWithdrawalBalance: 'Available amount',
    applyWithdrawalBalance: 'Withdraw amount',
    applyWithdrawalBalance2: 'Recharge amount',
    selectWithdrawalAccount: 'Select/input withdraw amount',
    withdrawRemark: 'Withdraw remark',
    withdrawRemark2: 'Recharge remark',
    inputWithdrawRemark: 'Input withdraw remark',
    cancel: 'Cancel',
    sure: 'Confirm',
    submitResigt: 'Submit application',
    oneWeek: 'One week',
    oneMonth: 'One month',
    threeMonth: 'Tree months',
    withdrawAmoutIsNotNull: 'Withdraw amount cannot be null!',
    withdrawAmoutZS: 'Please input positive integer!',
    withdrawAmoutMustNumber: 'Withdraw amount must be a number!',
    withdrawAmoutIsNot0: 'Withdraw amount must be greater than 0!',
    withdrawAmoutIsNotNegative: 'Withdraw amount cannot be negative!',
    withdrawAmoutIsNotEnough: 'Withdraw amount is not enough!',
    comformWithdrawMsg: 'Please check the withdraw massage if go on?',
    comformWithdrawMsgIfGo: 'Please check the withdraw massage if go on?',
    sureSubmit: 'Confirm and submit',
    returnEdit: 'Return and edit',
    submitSuccess: 'Submit succeeded,waiting for review!',
    companyName: 'Shop name',
    companyName2: 'Shop name',
    companyType: 'Shop type',
    distributor: 'Distributor',
    supplier: 'Supplier',
    inputCompanyNameAndId: 'Please input shop name/ID',
    handle: 'Process',
    auditor: 'Audit',
    auditorPass: 'Approved',
    auditorNotPass: 'Disapproved',
    withdrawHander: 'Withdraw processing',
    withDrawAuditor: 'Withdraw auditing',
    withDrawAuditor2: 'Recharge auditing',
    withdrawHander2: 'Recharge processing',
    refuseApply: 'Refuse application',
    refuseApplyReason: 'Please input reasons for refusal',
    handlingSubmittingAudits: 'Process and submit for review',
    handelSuccess: 'Process succeeded!',
    rechargeFail: 'Failure'
  },
  password: {
    getPassword: 'Get password',
    pleaseInputMailAccount: 'Please input the mail account',
    sendPasswordToMail: 'Send password to mail',
    returnToIndex: 'Return',
    sendMsg: 'Enter your registered director mail，systerm will initialize a password to the corresponding mail.',
    mattersNeedingAttention: 'Attention',
    tips1: 'Please do not retrieve the password frequently, use most of the day',
    tips2: 'Secondary retrieving function.',
    tipsMsg: 'Tips',
    loginAtonce: 'Login',
    getUrlAgain: 'Get again',
    mailCanNotBeEmpty: 'Mail cannot be blank!',
    mailStyleNotRight: 'Please enter a legitimate mailbox format!',
    mailHaveSendSuccess: 'Send succeeded,please verify in your mail!',
    theMailInputNotExist: 'The mail does not exist!',
    theMailNotHaveRight: 'The mailbox is not activated or banned',
    aboveOneDayPermit: 'Over the maximum of permitting operations one day!',
    mailSendFail: 'Mail send failed!'
  },
  orderMessage: {
    pleaseIntoConfirmEmail: 'Please input email',
    emailError: 'Email input format is incorrect',
    confirmEmailError: 'Email of confirmation slip has an incorrect format',
    pleaseIntoUseDate: 'Please choose a use date',
    pleaseIntprodDate: '请选择游玩时间',
    pleaseIntoHandDate: 'Please choose a receive date',
    pleaseIntoReturnDate: '请选择归还时间',
    pleaseIntoLinkCounter: '请选择领取柜台',
    pleaseIntoReturnCounter: '请选择归还柜台',
    pleaseIntoCustomEmail: 'Please enter visitor\'s name',
    pleaseSelectStock: 'Please choose the venue',
    customEmailLength: 'The length of visitor\'s name cannot more than 20',
    pleaseIntoCustomTel: 'Please enter visitor\'s phone number',
    pleaseIntoNationality: 'Please enter visitor\'s nationality',
    pleaseIntoBirthday: 'Please enter visitor\'s Birthday',
    customTelError: 'The format of visitor\'s mail is incorrect',
    customTelError1: 'Phone number format incorrect. Please enter a valid 10 or 11 digit phone number. ',
    customAgeError: 'Invalid age format. ',
    customSexError2: 'bus for exclusive use of the woman. Please select bus for exclusive use of the man. the correct passenger gender. ',
    customSexError1: 'bus for exclusive use of the man. Please select bus for exclusive use of the man. the correct passenger gender. ',
    pleaseIntoCustomWechat: 'Please enter visitor\'s wechat ID',
    customWechatError: 'The format of visitor\'s wechat ID',
    pleaseIntoCustomPass: 'Please enter visitor\'s passport ',
    customPassError: 'The format of visitor\'s passport is incorrect',
    pleaseIntoCustomAddress: '请输入快递地址',
    pleaseIntoCustomPostcode: '请输入邮政编码',
    customPostcodeError: '邮政编码格式不正确',
    pleaseIntoCustomCreditType: '请选择游客证件类型',
    pleaseIntoCustomCreditNo: '请输入游客证件号',
    customCreditNoError: '游客证件号格式不正确',
    customSexMale: 'Male',
    customSexFalmale: 'Female',
    customCtype1: '大人',
    customCtype2: '小児',
    customCtype3: '身障者大人',
    customCtype4: '身障者小児',
    pleaseRechangeCtype: 'Passenger type does not match with passenger details. Please select the correct passenger type. ',
    pleaseIntoCustomItem: 'Please input the visitor custom content',
    quotaPrompt: 'Please enter an integer greater than 0',
    orderOnceBeOne: 'The number of every single order is at least 1',
    orderNumberOnceBeOne: '单次订单预定人数至少为1',
    orderStockBeMax: '本产品场次库存数至多为',
    orderOnceBeMax: 'ERROR! The maximum number of this product per order is ',
    orderNumOnceBeMax: '本产品单次订单预定人数至多为',
    orderOnceBeMin: 'ERROR! The minimum order is from ',
    orderNumOnceBeMin: '本产品单次订单预定人数至少为',
    validateDateExpire: 'The expiry date has expired',
    productsNumError: 'ERROR. Lack of stock! Order cannot be completed!',
    productsNumError1: 'Product ',
    productsNumError2: ' - :',
    productsNumError3: ' Insufficient inventory',
    productsNumError4: ' Insufficient stock of PDF electronic tickets',
    productPriceError: '价格已变化，请重新刷新',
    systemErrorMsg: '系统异常,请稍后再试!',
    pleaseUploadPDF: '需先上传PDF文件才能确认！',
    pleaseIntoUseData: 'Please input the specified time',
    productUseDateBeNull: 'The specified time of orders cannot be null',
    jtrordermessage: '数量最多为',
    jtrplayDate: '请先选择游玩时间',
    jtrnum: '请选择数量',
    jtrphone: '请输入手机号',
    jtrphonefalse: '手机号不正确',
    linkCreditTypeErr: '请选择证件类型',
    linkCreditNoErr: '请输入证件号码',
    error: '订单无法追加、或已达到上限',
    limitedDate: 'The current time has exceeded the scheduled time limit of the product, please re-order',
    limitBulking: 'The distributor is in bulk purchase, cannot submit a new batch reservation before purchase complete, please wait!',
    designatedDateNull: 'The specified date is empty'
  },
  actuary: {
    all: '全部',
    actuaryType: '内容',
    actuaryType1: '预存款进款',
    actuaryType2: '请款书支付',
    actuaryType3: '临时采购',
    actuaryType4: '采购待支付',
    actuaryType5: '采购支付',
    actuaryType6: '售卖',
    actuaryState: '状态',
    actuaryState1: '正常',
    actuaryState2: '取消',
    actuaryState3: '完成',
    actuaryState4: '待处理',
    depositStatus0: '待处理',
    depositStatus1: '待审核',
    depositStatus2: '已完成',
    depositStatus3: '已拒绝',
    jphOrderStatus0: '待支付',
    jphOrderStatus1: '待确认',
    jphOrderStatus2: '取消中',
    jphOrderStatus3: '已取消',
    jphOrderStatus4: '已确认',
    jphOrderStatus5: '已完成',
    jphOrderStatus6: '未支付取消',
    jtrOrderStatus0: '待确认',
    jtrOrderStatus1: '待支付',
    jtrOrderStatus2: '已完成',
    jtrOrderStatus3: '取消订单',
    jtrOrderStatus4: '已付款',
    jtrOrderStatus5: '已申请退款',
    jtrOrderStatus6: 'Refunded',
    jtrOrderStatus7: '支付失败',
    jtrOrderStatus8: '拒绝退款',
    jtrOrderStatus9: '已出票',
    searchTime: '日期',
    searchWords: 'Keywords',
    searchMsg: '分销商名称/产品名称/设施',
    search: '搜索',
    exportExcel: 'Excel下载',
    addNew: '新增',
    actuaryId: '号码',
    createTime: '日期',
    facilitiesName: '设施',
    distributorName: '分销商',
    productName: '商品名',
    productNum: '张数',
    depositAmount: '预存款',
    payoutAmount: '支出',
    incomeAmount: '进价',
    saleAmount: '销售额',
    distributorBalance: '分销商预存款余额',
    salableQuantity: '可售张数',
    stockQuantity: '实际在库',
    operation: '操作',
    viewNum: '张数',
    viewNumErr: '张数不能为空或负数',
    view: '景点',
    viewIdErr: '景点必选',
    viewIdErr1: '只能选择一个景点',
    amount: '金额',
    amountErr: 'Amount cannot be blank',
    requestForm: '请求书',
    payDate: '支付日',
    payDateErr: '支付日不能为空',
    remark: '备考',
    remarkErr: '备考不能为空',
    validTime: '有效期',
    addAmount: '合计金额',
    money: '日元',
    confirm: '确认',
    timeSlot: '选择输入时间段',
    nameErr: '设施不能为空',
    validDateErr: '有效期不能为空',
    productInfo: '注 : 当前仅支持选择一种产品',
    productErr: '产品不能为空',
    productErr1: '当前只能选择一种产品',
    chooseActuaryType: '请选择新增精算类型',
    messageNotCompleteIn: '必要信息未输入完整',
    addSuccess: '添加成功',
    addError1: 'Add error,Products Existing or Not Selected',
    addError2: 'Add error',
    submitPrice: 'Prices cannot be empty!',
    submitMinPrice: 'Min price cannot be empty!',
    submitMinPrice0: 'The minimum amount required to enter cannot be less than or equal to 0!',
    submitMinPrice1: '分销价格必须大于0!',
    submitOrderNum: 'Sort cannot be empty!',
    submitLength: 'Price and ranking must be less than or equal to 10 digits',
    addFailed: 'System exception, please try again later',
    operatorBalance: '余款',
    actuaryDetail: '精算详情'
  },
  finance: {
    calculatePeriod: 'Settlement cycle：',
    calculatePeriod1: 'Settlement cycle',
    placeholderCalculatePeriod: 'Choose the settlement cycle',
    supplierNameAndId: 'Shop name/ID：',
    placeholderSupplierNameAndId: 'Please input shop name/ID',
    search: 'Search',
    supplierName: 'Shop name',
    distributorPayoutAmount: 'Receivable（JPY）',
    operatorIncomeAmount: 'Commission（JPY）',
    supplierIncomeAmount: 'Settlement（JPY）',
    operation: 'Operation',
    detail: 'Detail',
    downloadBill: 'Download the bill',
    lastSixMonth: 'Last six months',
    return: 'Return',
    distributorName: 'Distributor name：',
    distributorName1: 'Distributor name',
    placeholderDistributorName: 'Please enter the distributor name/ID',
    finishTime: 'Finish time',
    orderId: 'Order ID',
    productId: 'Product ID',
    productName: 'Product name',
    productType: 'Product type',
    elecTicket: 'E-ticket',
    paperTicket: 'Entity ticket',
    experTicket: 'Experience',
    daysTicket: 'Day/Days Tour',
    wifi: 'Wi-Fi',
    sim: 'SIM Card',
    restTicket: 'Food',
    traffTicket: 'Traffic',
    packTicket: 'Dicount Tickets',
    distributorPayoutAmount1: 'Receivable',
    operatorIncomeAmount1: 'Commission',
    supplierIncomeAmount1: 'Settlement'
  },
  payOrder: {
    payMessageOne: 'Please check the order details for any mistakes before proceeding to payment.',
    payMessageOne1: 'The order will be cancelled automatically after one hour if the payment is not processed. ',
    payMessageOne2: 'Please complete the payment as soon as possible to confirm the order.',
    payMessageOne3: 'Tickets are limited and are not booked and confirmed until payment is processed.',
    jtrpayMessageOne: 'Please confirm the details of the order at the end of the order.',
    jtrcancel: 'Cancel part of the order',
    jtrAppend: '追加订单',
    jtrpayMessageTwo: 'No payment in minutes will be cancelled.',
    payMessageTwo: 'Please pay as soon as possible,otherwise the product will be sold out and the order cannot be purchased.',
    payMessageThree: 'Order',
    payMessageFour: 'It will be canceled if not paid within minutes. Please pay as soon as possible.',
    payMessageFive: 'Payment times out, please place the order again.',
    lineDownTicket: 'Line down electronic ticket',
    lineUpTicket: 'Online electronic ticket',
    salaryByNow: 'Payment',
    thirdPayment: 'E-wallet payments',
    canBeUseMoney: 'Available account balance：',
    jtrcanBeUseMoney: 'Payment amount',
    remainTimes: 'Validity period',
    payMoney: 'Total cost：',
    applyCancel: 'Apply for cancellation',
    payByNow: 'Pay now',
    canBeUseMoneyError: 'Available balance is not enough,order cannot be generated',
    orderCanceled: 'Order cancelled',
    consentRefund: '已同意退款',
    refuseRefund: '已拒绝退款',
    overTimeByPay: 'Payment times out and the order is cancelled automatically.',
    orderHaveUpdate: '支付失败，订单状态已更新',
    orderException: '订单异常，请重试',
    productException: '产品异常,无法编辑说明',
    payerror: '支付失败',
    error: 'Cancelling the number of errors',
    applyerror: 'Application failure'
  },
  supplyOrder: {
    confirmCancel: 'Confirm cancel',
    refuseCancel: 'Refuse cancel',
    canceleOrder: 'Cancel order',
    specialCanceleOrder: 'Special Cancel',
    partnerCancleOrder: 'Cancel API of connection destination',
    jtrSpecialCanceleChannel: 'Special cancellation of pass',
    writeFff: 'Write off',
    confirmSpecialRefund: '确认特殊退款',
    refuseSpecialRefund: '拒绝特殊退款',
    orderConfirmDetail: 'Details and QR code',
    system: 'System',
    checkedForNew: 'Click to see the latest message',
    orderRefuseMessage: 'This product cannot be refunded,the payment will not be returned if the application is cancelled, please be notified',
    canBeTakeBackFree: 'Refund fee',
    canBeTakeBack: 'Refund poundage',
    exchangeRate: '汇率差额',
    takeMoney: 'Returned money',
    orderDetailByDialog: 'Details and QR code',
    orderdetail1: 'Order①',
    orderdetail2: 'Order②',
    orderdetail3: 'Order③',
    orderdetail4: 'Order④',
    orderdetail5: 'Order⑤',
    orderdetail6: 'Order⑥',
    orderdetail7: 'Order⑦',
    orderdetail8: 'Order⑧',
    orderdetail9: 'Order⑨',
    fileTypes: 'This file is not in a valid pdf format!',
    reselectFile: 'The PDF file is not included in this file. Please re-select it!',
    zipTypes: 'This file is not in a valid ZIP format!',
    fileSize: 'The size of uploaded pdf cannot exceed 5MB！',
    fileTypeBy: 'The file name cannot have a comma!',
    canCancel: 'Cancel',
    downFiles: 'Download files',
    vailTimeMsg: 'Order status does not support modifying the validity period',
    vailTimelaterMsg: 'The end date cannot be less than the current date',
    vailTimeFsjMsg: 'Fujikyu products do not support changing the validity period',
    vailTimeEmpty: 'Please select the validity period'
  },
  productNumberPrice: {
    pleaseIntoTime: 'Please select time',
    pleaseIntoNumber: 'Please fill the stock',
    pleaseGetOneToSix: 'Please enter 1-6 numbers',
    pleaseIntoPurchasePrice: 'Please fill the purchase price ',
    pleaseIntoDistorbutionPrice: 'Please fill the distribution price',
    pleaseIntoMarketPrice: 'Please fill the market price',
    dateCanotBeNull: 'Date cannot be null',
    confirmDateCanotBeMax: 'The set time period must be within the product\'S sale time!',
    distributorCanotBuyMessage: 'Reservation cannot be made because you do not have permission to sell the product',
    distributorCanotBuyMessage2: 'This product is offline. You can\'t buy this product'
  },
  pwdSet: {
    pleaseIntoOldPwd: 'Please enter the original password ',
    pleaseIntoNewPwd: 'Please enter the new password ',
    pleaseConfirmPwd: 'Please confirm new password ',
    pleaseIntoIntoSix: 'Please enter 6-16 capital or small English letters or numbers',
    mustBeOne: 'Must be consistent with the above input',
    pleaseIntoCorrectPwd: 'Please enter the correct password ',
    lengthMustOneToSix: 'Length must between 6 to 16 characters',
    canotBeIntoNull: 'Cannot input blank or other characters',
    updateNewPwdSuccess: 'Update new password succeeded,please login again!',
    oldPwdError: 'Old password is error，please try again!',
    oldAndNewNotOne: 'Entered passwords differ!',
    pleaseIntoMustItem: 'Please enter the must item',
    pleaseEnterPwd: 'Please enter the password',
    pleaseEnterPwdAgain: 'Please enter the password again'
  },
  homeMessage: {
    urgnMessage: 'You have no permission to operate this function!'
  },
  entityTicket: {
    pinTicketNo: 'Pin ticket Number',
    selectDepot: 'Select depot',
    pleaseSelect: 'Please select',
    selectProduct: 'Select product',
    relationProduct: 'Associated Products',
    selectPriceType: 'Select product price type',
    saveTicketDepot: 'Save the ticket depot',
    onlySelectOnePro: 'Adding a ticket depot at one time only allows an alternative product!',
    onlySelectOnePriceType: 'Adding a ticket depot at one time only allows an alternative product Price Type!',
    depotNameNotBeEmpty: 'Depot name cannot be empty!',
    productNameNotBeEmpty: 'Product name cannot be empty!',
    productPriceTypeNotBeEmpty: 'Product type cannot be empty!',
    addSuccess: 'Add succeeded!',
    inDepotSuccess: 'Stored succeeded!',
    proHaveExist: 'This product has already existed!',
    selectDepotOut: 'Out depot',
    selectDepotIn: 'Entry depot',
    depotProNum: 'Inventory',
    validDate: 'Valid date',
    selectDate: 'Select date',
    starEndTicketNo: 'Start and end ticket number',
    starTicketNo: 'The initial ticket number',
    endTicketNo: 'The end ticket number',
    inDepotTicketNo: 'Entry ticket number',
    textArea: 'Separate scavenging entrance,move the cursor to here and then sweep dimensional code on a solid ticket by scavenging gun',
    saveToDepot: 'Save and entry',
    pleaseInputStarTicketNo: 'Please input the initial ticket number!',
    pleaseInputEndTicketNo: 'Please input the end ticket number!',
    errorMsg01: 'The initial ticket number must be no more than 10 digits!',
    errorMsg02: 'The end ticket number must be no more than 10 digits!',
    errorMsg03: 'The initial ticket number cannot be more than the end one!',
    errorMsg04: 'The number of entry tickets cannot be more than 2000!',
    errorMsg05: 'The length of following ticket number is longer than tens digit',
    errorMsg06: 'Please select the entry warehouse!',
    errorMsg07: 'Out warehouse cannot be the same as the entry warehouse!',
    errorMsg08: 'Please select the expiry date!',
    errorMsg09: 'Please input the ticket number of entry!',
    errorMsg10: 'This entry warehouse and this product have not yet been set up in the warehouse,please set up a warehouse before input!',
    errorMsg11: 'Following ticket number exist in the entry warehouse ',
    errorMsg12: 'Following ticket number does not exist in the out warehouse',
    errorMsg13: 'This out warehouse and this product have not yet been set up in the warehouse,please set up a warehouse before output!',
    allBathList: 'Lists of all batches',
    batchDetailList: 'Detail list of batch',
    batchNO: 'Batch ID',
    ticketNO: 'Ticket number',
    pleaseInputBatchNo: 'Please input the batch id',
    pleaseInputTicketNo: 'Please input the ticket number',
    inDepotTime: 'Warehousing date',
    inDepotUser: 'Warehousing user',
    importNumber: 'Total',
    userNumber: 'Quantity of usage',
    invalidateNumber: 'Invalid',
    leftNumber: 'Left',
    exportNumber: 'Export',
    thisBatchDetail: 'Details',
    clearDepot: 'Clear',
    batchState: 'Batch state',
    ticketState: 'Ticket state',
    stateOne: 'Normal',
    stateTwo: 'Used',
    stateThree: 'Cancel',
    stateFour: 'Exported',
    stateFive: 'Cleared',
    stateSix: 'Locked',
    userOperationTime: 'Operation（Cancel） time',
    unUseRemark: 'Invalidation description',
    orderId: 'Order ID',
    sureClearDepot: 'Are you sure to clear this batch of products?',
    sureClearDepot2: 'Are you sure to clear this depot?',
    clearDepotSuccess: 'Clear succeeded',
    haveCancelClearDepot: 'Have cancel the clearance of depot!',
    invalidTicketSuccess: 'All invalidated succeeded!',
    addTicketDepot: 'Add ticket depot',
    depot: 'Depot',
    keyWorld: 'Keyword',
    inputProNameAndNo: 'Please input product name/number',
    userTimeQuantum: 'Using time',
    inputSelectTimeQuantum: 'Select/input queried time',
    depotId: 'Depot ID',
    ticketDepotId: 'Ticket DepotID',
    depotName: 'Depot name',
    productId: 'Product ID',
    productName: 'Product name',
    fileName: 'Total',
    depotIn: 'Warehousing',
    depotId2: 'Input',
    depotId3: 'to',
    depotId4: 'The initial inventory',
    depotOut: 'Output',
    history: 'Record',
    zhang: 'Zhang',
    operationUser: 'Operator',
    depotType: 'Depot type',
    addDepot: 'Add depot',
    inputDepotName: 'Please input the depot name',
    notAllDepot: 'Not central warehouse',
    allDepot: 'The central warehouse',
    depotRemark: 'Depot remark',
    remarkMsg: 'Remark',
    inventoryNumber: 'Inventory',
    ifIsAllDepot: 'Central warehouse sign',
    yes: 'YES',
    no: 'NO',
    tips: 'Note:there is only one central warehouse',
    depotEdit: 'Edit the depot',
    deleteDepot: 'Sure to delete this depot?',
    depotNameIsNotEmpty: 'Depot name cannot be empty!',
    allDepotOnlyOne: 'The central warehouse is only allowed to have one!',
    depotNameOnlyOne: 'This depot name has already existed!',
    userDepotManager: 'Management of users\' depot',
    addDepotToUser: 'Appointed depot',
    addDepotToUserSuccess: 'Appoint succeeded!',
    notHistory: 'This product has no history!',
    pleaseSelectInvalidTicket: 'Please select invalid ticket!',
    invalidTicketFalid: 'All invalid failed!',
    someInvalidTicketFalid: 'Fail to cancel the following ticket numbers.',
    orderQuery: 'Order query：',
    orderQueryPlac: 'Please enter order number or scan code.',
    orderInfo: 'Order Info：',
    startStopNumber: 'Start and end ticket number：',
    startNumber: 'The initial ticket number',
    stopNumber: 'The end ticket number',
    numberEditPlac: 'Separate scavenging entrance,move the cursor to here and then sweep dimensional code on a solid ticket by scavenging gun',
    confirmPin: 'Confirm the pin ticket',
    formMsg1: 'Please enter the verification code, order number or scan code.',
    rule_n1_10: 'Length limited within 1 to 10',
    querySuccess: 'Query Success',
    queryFailure: 'Order does not exist',
    queryMsg1: 'The starting ticket number can\'t be greater than the ending ticket number, and can only 100 tickets at most once.',
    queryMsg2: 'Confirm the pin ticket：',
    pinMsg1: 'Pin ticket success',
    pinMsg2: 'Pin ticket fail!',
    clearRemark: 'Inventory remark'
  },
  ticketMessage: {
    pleaseEnterOrderId: 'Please enter your reservation number.',
    depotName: 'Depot name：',
    pleaseIntoDepotName: 'Please input depot name',
    depotNameNotNull: 'Depot name cannot be blank',
    ticketRemark: 'Remark：',
    remarkNotNull: 'Remark cannot be blank',
    pleaseGetProduct: 'Please choose product',
    fileDepotName: 'File depot name：',
    batchStatus: 'Batch status：',
    batchId: 'Batch ID',
    pleaseEnterBatchId: 'Please input the batch id',
    enterDate: 'Import date',
    enterUser: 'Import user',
    close: 'Close',
    Processing: 'Processing',
    uploadFailure: 'upload failure',
    ticketDetail: 'Detail',
    newToUse: 'Priority use',
    fileStatus: 'File status：',
    fileName: 'File name：',
    pleaseEnterFileName: 'Please input the PDF file name',
    fileId: 'File ID',
    fileNames: 'File name',
    downPdf: 'Download PDF',
    ticketMessageBy: 'Following tickets are in an abnormal state，delete failed!',
    noUseMessage: 'Select at least one file!',
    ticketMessageBy2: 'This operation has an abnormal ticket,please retry again after refresh!',
    operationSuccess: 'Operation succeeded!',
    getFile: 'Choose file',
    getZipFile: 'Choose ZIP',
    getFilesOnlyFive: '*Note: Each PDF will be split into multiple e-tickets by page. Limit the quantity of uploaded PDF files to 5 and a single file size can\'t exceed 10MB',
    getZipOnlyOne: 'Limit the quantity of uploaded ZIP files to 1 and a single file size can\'t exceed 300MB',
    usedDate: 'Expire date：',
    usedDates: 'Expire date',
    ticketMessageBy3: 'Null is always valid.',
    intoNow: 'Import now',
    intoSuccess: 'Import succeeded!',
    insertFileDepot: 'Add file depot',
    choose: '选择',
    fileDepotNames: 'File depot name',
    pleaseIntoFileName: 'Please input file name',
    canBeUseDate: 'Used（cancel） time：',
    intoSearchDate: 'Input search date',
    into: 'Import',
    fivePdf: 'PDF!',
    oneZip: 'ZIP!',
    ticketOpen: 'Open',
    intoIng: 'Importing, please wait...',
    fileHadExists: 'The file already exists in the library!',
    uploadSize: 'The uploaded picture size should not exceed 10MB!',
    uploadZipSize: 'The uploaded picture size should not exceed 300MB!',
    fileNotFors: 'Don\'t upload files repeatedly!',
    pleaseGetFile: 'Please select file',
    fileBatchRemarkNotNull: 'Please enter remark'
  },
  remind: {
    remindId: 'The serial number',
    title: 'Email alerts',
    date: 'Send mass of date',
    accessory: 'The attachment',
    add: 'New remind',
    upload: 'To upload attachments',
    beforeDay: 'Send an email notification N days before the group date',
    before: 'Hair group has',
    days: 'Send email reminders days',
    download: 'Download the attachment',
    reminder: 'prompt',
    confirm: 'determine',
    inputDate: 'Please enter the date of dispatch',
    uploadAccessory: 'Please upload the attachment.',
    inputbeforeDay: 'Please enter advance delivery date',
    inputContent: 'Please enter the message content',
    sendContent: 'Send content',
    addRemind: 'Email alerts',
    existRemind: 'A day reminder already exists',
    set: 'Email Settings'
  },
  trades: {
    platform: 'Platform',
    excel: 'Export to Excel',
    tradesTime: 'Trades Time',
    inputOrderId: 'Please enter the order number',
    tradingTime: 'Trading Date',
    operatorUser: 'Operator',
    expenditure: 'Expenditure',
    income: 'Income',
    buyQuantity: 'Num of Units',
    customerName: 'Traveler Name',
    orderExplain: 'Order Info',
    content: 'Content'
  },
  pinTicketMagn: {
    pinTicket: 'Pin ticket',
    shortcutOut: 'Shortcut pin ticket',
    all: 'All',
    pinTime: 'Authentication time',
    validationType: 'Pin ticket type：',
    productName: 'Product name：',
    placeholder1: 'Please enter the product name',
    validateTime: 'Pin ticket date：',
    placeholder2: 'Please select the pin ticket date.',
    orderId: 'Order ID：',
    placeholder3: 'Please enter the order id',
    distributor: 'Distributor：',
    placeholder4: 'Please enter the distributor',
    validationUser: 'Verifier：',
    placeholder5: 'Please enter the verifier',
    ticketNo: 'Ticket number：',
    placeholder6: 'Please enter the ticket number',
    colOrderId: 'Order ID',
    colOrderContent: 'Product content',
    colValidateTime: 'Pin ticket time',
    colValidateType: 'Type',
    colValidateUser: 'Verifier',
    colDistributor: 'Distributor',
    colCustomerOrderNo: 'Shortcut NO.',
    placeholder7: 'Please enter the express ticket No',
    colCustomerOperator: 'Operator',
    placeholder8: 'Please enter operator',
    colticketNo: 'Ticket number',
    shortcutOutDepot: 'Pin ticket depot',
    shortcutOutProduct: 'Pin ticket product',
    company: 'Company',
    orderIdNo: 'Order ID',
    distributorNameAndOrderNo: 'Distributor name (suggested: initials) +order number',
    pleaseInputOrderCustomer: 'Please enter the customer order ID',
    pleaseInputCustomerOperator: 'Please enter the operator',
    shortcutOutSure: 'Confirm the pin ticket',
    ticketCanNotBeCutOut: 'The following tickets can\'t be pined.',
    ticketCanNotBeCutOuts: 'Do not enter duplicate ticket numbers.',
    distributeOnlySelectOne: 'The distributor can only choose one.',
    ticketNumber100: 'The number of incoming tickets can\'t be greater than 100!',
    pleaseInputDistribute: 'Please Select Distributor!',
    pleaseInputOrder: 'Please enter the order ID!',
    orderLine100: 'The length of order ID cannot more than 100!',
    inputOperation: 'Please enter the operator!',
    operationLine100: 'The length of Operator cannot more than 100',
    shortcutOutSuccess: 'Pin ticket success!'
  },
  errMsg: {
    errMsg100: 'Order does not exist',
    errMsg101: 'No corresponding warehouse',
    errMsg102: 'Only operator could delete it',
    errMsg103: 'This order is no longer valid',
    errMsg104: 'The following tickets can\'t be pined.',
    errMsg105: 'Operation from carrier or supplier with special permissions to pass the audit is failed',
    errMsg106: 'Product ID cannot be empty',
    errMsg107: 'Updload file cannot be empty',
    errMsg108: 'Server inner error',
    errMsg109: 'The order has been completed',
    errMsg110: 'Order not confirmed',
    errMsg111: 'The number to delete doesn\'t match the number purchased',
    errMsg112: 'No corresponding ticket warehouse',
    errMsg113: 'No conrresponding ticket',
    errMsg114: 'Please select the product source',
    errMsg115: 'Enter at least one',
    errMsg116: 'The order has been cancelled',
    errMsg117: '',
    errMsg118: '',
    errMsg119: '',
    errMsg120: '',
    errMsg121: 'In process, do not submit again'
  },
  pay: {
    type: 'Recharge method',
    success: 'Payment completed',
    fail: 'Payment incompleted',
    toUrl: 'Please go the the payment platform you chose to complete the payment',
    toPay: 'Go on recharging',
    error01: 'Payment failed, please try again',
    error02: 'Payment is completed, please do not repeat the payment',
    loading: 'Payment data is under processing...',
    message: '支払いが成功したら、振込はサービス方で遅れます。お待ちください。'
  },
  pageSetting: {
    upload01: 'Only files in jpg/png/jpeg format and size not more than 1MB can be uploaded',
    upload02: 'The size of the homepage pictures is 1920x500 pixels, and the element pattern of the homepage pictures needs to be 430 pixels from the left. ',
    pageImg: ' Homepage pictures：',
    errorByPage01: 'There is no change in the homepage pictures',
    errorByPage02: 'The homepage pictures can not be empty！'
  },
  barCode: {
    urlError: 'Url Error!',
    getInfoError: 'QRCode Loading Error!',
    productTextDescription: 'Reservation details',
    customerReceiveDate: 'Ticket collection date：',
    returnDate: 'Return Date：',
    productUseDate: 'Selected date：',
    buyQuantity: 'Order details：',
    productUseFlow: 'How to use：',
    productUseName: 'Guest name(s)：',
    validityDate: 'Ticket valid period：'
  },
  supplementInfo: {
    urlError: '地址链接异常!',
    getSupplementInfo: '内容获取失败!',
    supplementOfUseFlow: '使用流程补充详细说明'
  },
  qrCode: {
    qrCodeSource: 'Name',
    isDistribution: 'Distributor',
    scale: 'Commission rate',
    YES: '是',
    NO: '否',
    noValue: 'Commission rate value empty',
    distributionRange: 'Distribution Product Scope Authorization',
    distributionRangeAll: 'All qrcodes distributable',
    distributionRangeYes: 'Designated qrcodes are distributable',
    distributionRangeNo: 'qrcodes are distributable except for specified qrcodes',
    selectDistributor: 'Product selection',
    tipMessage1: 'Please enter a name',
    tipMessage2: 'Please select the scope of authorization',
    tipMessage3: 'Please enter commission rate',
    addError1: 'Two-dimensional code source already exists, please re-enter',
    prompt: 'Are you sure to delete the two-dimensional code?？',
    searchMore: 'View products',
    choseCode: 'Selection of two-dimensional codes',
    choseCodeError: 'Please select two-dimensional code',
    nickName: 'Nickname',
    auditStatus: 'Audit status',
    submitAudit: 'Confirmation of approval?',
    submitAudit1: 'Confirm cash withdrawal?',
    cannotSale: 'Products purchased through the QR Code after the user has been deactivated will not receive commission fee.',
    canSale: 'Products purchased through the QR Code after the user has been activated will process commission fee. ',
    remark: 'Remarks',
    agree: 'Accept',
    handle: 'Process',
    notAgree: 'Decline',
    applyMoney: 'Withdrawal amount',
    applyMoney1: 'Withdrawal amount(excluding fees)',
    chargeMoney: 'Commission fee',
    chargeMoney2: 'Including fees',
    aduitTime: 'Review time',
    aduitName: 'Auditor',
    remittanceExport: 'Export Remittance Data',
    realName: 'Account holder\'s name',
    bankNo: 'Account number',
    bankName: 'Bank name',
    branchName: 'Branch name',
    accountType: 'Account type',
    tocDistributor: 'Distributor',
    distributorName: 'Distributor nickname',
    twoDistributor: 'Distributor',
    oneDistributor: 'Distributor',
    drawaltip1: 'Withdrawal amount exceeds current balance.',
    drawaltip2: 'Withdrawal amount less than commission fee.',
    drawaltip3: 'Please enter withdrawal amount.',
    drawaltip4: 'Please wait for the pending cash withdrawal request to be processed. ',
    saleName: 'Username',
    saleMoney: 'Distributor Revenue',
    distributorMoney: 'Distributor Revenue',
    isHasMoney: 'Deposit status',
    isPay: 'Cash deposited',
    notPay: 'Unpaid',
    handleStatus: 'Processing status',
    handleStatus1: 'Pending processing',
    handleStatus2: 'Processed',
    handleStatus3: 'Declined',
    handleBy: 'Processed by',
    handleTime: 'Time of Process',
    setCharge: 'Manage Commission Fee',
    chargeConfirm: 'Finalise withdrawal fees?',
    accountStatus: 'Account Status',
    canUse: 'Enable',
    cannotUse: 'Disable',
    cannotUse1: 'Disconnected',
    incomeAmount: 'Amount of earnings',
    tocIncomeAmount: 'Customer account balance',
    withdrawalError1: 'Please enter account holder\'s name',
    withdrawalError2: 'Please enter account number',
    withdrawalError3: 'Please enter bank name',
    withdrawalError4: 'Please enter branch name',
    withdrawalError5: 'Please enter account type',
    handleError1: 'Insufficient balance, withdrawal request declined.',
    handleError2: 'Cash withdrawal access restricted to operating user. ',
    handleError3: 'Insufficient balance, withdrawal request declined.',
    withdrawalTips: 'Purchases of 10,000 JPY or more: No fees. Purchases less than 10,000 JPY will incur a fee',
    withdrawalTips1: 'Purchases of 10,000 JPY or more: No fees. ',
    withdrawalTips2: 'Purchases less than 10,000 JPY will incur a fee',
    applyCash: 'Cash Withdrawal',
    applyBy: 'Applicant type',
    applyUser: 'Applicant',
    twoApplyName: 'Distributor',
    cannotCharge: 'The set amount can only be a positive integer',
    name: 'name',
    Unbundling: 'Disconnect',
    UnbundTips: 'Once disconnected, this user will not receive further sales commissions. ',
    cannotUnbund: 'This user has a commission transfer in progress. Unable to disconnect. ',
    twoApplyNameID: 'Distributor ID',
    inputScale: 'Please enter the percentage of commission for distribution. ',
    keyTips: 'Distributor ID/Nickname',
    saleLog: 'Direct sales record',
    withdrawalTips4: 'Cannot withdraw due to insufficient balance'
  },
  payWay: {
    balance: 'Account balance',
    weChat: 'Wechat',
    alipay: 'Alipay',
    creditCard: 'CreditCard',
    unionPay: 'UnionPay',
    weChatWay: 'Wechat Pay',
    payedId: 'Payment order No',
    alipayWay: 'Alipay',
    linePay: 'Line Pay',
    grabPay: 'Grab Pay',
    zaloPay: 'Zalo Pay',
    aliPayHK: 'AlipayHK',
    isPay: 'Reservation settlement',
    codeTips: 'QR code expired, please reacquire',
    codeTips1: 'QR code reacquisition',
    codeTips2: 'On WeChat',
    codeTips3: 'Scan the QR code',
    codeTips4: 'On Alipay',
    codeTips5: 'Scan the QR code',
    codeTips6: 'On Camera',
    refundTips: 'The reservation has been canceled and the full payment will be refunded to the payer. Thank you for your receipt.',
    refundTips1: 'The reservation has already been paid and the full amount of the payment will be refunded to the payer. Thank you for your receipt.',
    refundTips2: 'Please note that depending on the payment method of the reservation, no refund will be given if the payment exceeds 30 days.',
    refundTips3: 'If your reservation has failed or you have already paid, we will refund the full amount to the payer. Thank you for your receipt.',
    errorTips: 'Failed to obtain payment information, please try again',
    partialRefundTips: 'In case of partial refund, the handling fee is not refundable',
    payTitle: 'Partner Order payment'
  },
  newHome: {
    priceFormat: '<span class="price-format">From</span> JPY {0}',
    expired: 'Login expired, please log in again ',
    searchPlaceholder: 'Search destinations/activities',
    searchButton: 'Search',
    searchResults: 'results available for booking ',
    category: {
      transport: 'Transport',
      themePark: 'Admission Tickets ',
      wifi: 'WiFi & SIM Card',
      carRental: 'Special Packages ',
      dayTrip: 'Day Trips & Multi-day',
      hotel: 'Experiences & Dining '
    },
    productSaleLabel: {
      osakaSalesOffice: 'Osaka Office',
      tokyoSalesOffice: 'Tokyo Office',
      fukuokaSalesOffice: 'Fukuoka Office',
      kyotoSalesOffice: 'Okinawa Office ',
      nagoyaSalesOffice: 'Nagoya Office',
      hokkaidoSalesOffice: 'Hokkaido Office'
    },
    popularCities: 'Popular Destinations ',
    popularCitiesEn: 'Popular Destinations & Seasonal Events Collection ',
    activeNumber: 'activities',
    balance: 'Balance',
    switchToOldVersion: 'Switch to Old Version ',
    switchToNewVersion: 'Switch to New Version ',
    viewMore: 'View More',
    all: 'All',
    sortBy: 'Sort by',
    easyGoRecommend: 'EasyGo Recommended',
    allDates: 'Date',
    priceRange: 'Price Range',
    other: 'Others',
    selectedExperiences: 'Selected Must-Try Experiences ',
    topActivities: 'Top Activities in Japan ',
    sales: 'Sales',
    price: 'Price',
    stockQuery: 'Stock on Request ',
    noProducts: 'No Data Available ',
    salesLessThan1k: ' Less than 1k ',
    sortOptions: {
      new: 'Newest',
      sales: 'Best Selling'
    },
    autoConfirm: 'Instant Confirmation ',
    secondConfirm: 'Manual Confirmation'

  }
}



// WEBPACK FOOTER //
// ./src/local/en_us.js